
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("leiBZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0ca0d45c08d5e8b7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "HistoryItemComponent", () => (parcelRequire("hgkcz")).default);
$parcel$export(module.exports, "HistoryItem", () => (parcelRequire("53f0u")).default);
$parcel$export(module.exports, "useIssueHistoryUi", () => (parcelRequire("2hhAC")).useIssueHistoryUi);
$parcel$export(module.exports, "Change", () => (parcelRequire("jVbrS")).default);
$parcel$export(module.exports, "GroupedChange", () => (parcelRequire("k4aVr")).default);

var $eUqFw = parcelRequire("eUqFw");

var $fee69 = parcelRequire("fee69");

var $kRR5t = parcelRequire("kRR5t");

var $gferK = parcelRequire("gferK");

var $hgkcz = parcelRequire("hgkcz");

var $53f0u = parcelRequire("53f0u");

var $2hhAC = parcelRequire("2hhAC");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");
const $0ca0d45c08d5e8b7$var$IssueHistoryContainer = ({ baseUrl: baseUrl, issueKey: issueKey, timeZone: timeZone, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntryComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fee69.ErrorBoundaryFlag), {
        id: "issue-history"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kRR5t.TimeZoneProvider), {
        value: timeZone
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gferK.default), {
        baseUrl: baseUrl,
        issueKey: issueKey,
        sortOrder: sortOrder,
        GroupedActivityEntryComponent: GroupedActivityEntryComponent
    })));
var $0ca0d45c08d5e8b7$export$2e2bcd8739ae039 = $0ca0d45c08d5e8b7$var$IssueHistoryContainer;

});
parcelRegister("kRR5t", function(module, exports) {

$parcel$export(module.exports, "TimeZoneProvider", () => $2fed3b9229bff908$export$da03264bca545d75);

var $eUqFw = parcelRequire("eUqFw");

var $6aKs0 = parcelRequire("6aKs0");
const { Provider: $2fed3b9229bff908$var$Provider, Consumer: $2fed3b9229bff908$export$f45fbe45e97edb6f } = /*#__PURE__*/ (0, $eUqFw.createContext)((0, $6aKs0.SYDNEY_TIMEZONE));
const $2fed3b9229bff908$export$da03264bca545d75 = (props)=>{
    const { children: children, value: value } = props;
    // Set default again if one attribute is undefined
    const memoizedValue = (0, $eUqFw.useMemo)(()=>value ?? (0, $6aKs0.getBrowserTimeZone)(), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2fed3b9229bff908$var$Provider, {
        value: memoizedValue
    }, children);
};

});

parcelRegister("gferK", function(module, exports) {

$parcel$export(module.exports, "default", () => $279827b49a6f4503$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $xdRNY = parcelRequire("xdRNY");

var $djQa4 = parcelRequire("djQa4");

var $gW4YY = parcelRequire("gW4YY");

var $7SwYz = parcelRequire("7SwYz");
const $279827b49a6f4503$var$HistoryItemsDI = (0, $7SwYz.default);
const $279827b49a6f4503$var$IssueHistory = ({ baseUrl: baseUrl, issueKey: issueKey, sortOrder: sortOrder, HistoryItems: HistoryItems, IssueHistoryService: IssueHistoryService, GroupedActivityEntryComponent: GroupedActivityEntryComponent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.FeedContainer), {
        "data-testid": "issue-history.ui.feed-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssueHistoryService, {
        baseUrl: baseUrl,
        issueKey: issueKey,
        sortOrder: sortOrder
    }, ({ loading: loading, loadingMore: loadingMore, hasMore: hasMore, loadMore: loadMore, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xdRNY.default), null);
        if (error) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HistoryItems, {
            history: data,
            hasMore: hasMore,
            isLoadingMore: loadingMore,
            onLoadMore: loadMore,
            sortOrder: sortOrder,
            GroupedActivityEntryComponent: GroupedActivityEntryComponent
        });
    }));
$279827b49a6f4503$var$IssueHistory.defaultProps = {
    HistoryItems: $279827b49a6f4503$var$HistoryItemsDI,
    IssueHistoryService: (0, $gW4YY.default)
};
var $279827b49a6f4503$export$2e2bcd8739ae039 = $279827b49a6f4503$var$IssueHistory;

});
parcelRegister("xdRNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da0de659ae0ee53$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $c9TLT = parcelRequire("c9TLT");

var $hJ992 = parcelRequire("hJ992");

var $hCroN = parcelRequire("hCroN");

var $2xN2s = parcelRequire("2xN2s");

var $iMstM = parcelRequire("iMstM");

var $3o7jb = parcelRequire("3o7jb");

var $c75Wq = parcelRequire("c75Wq");

var $keOMr = parcelRequire("keOMr");

var $84CBi = parcelRequire("84CBi");
const $6da0de659ae0ee53$var$activityItemSkeleton = (isModal)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$AvatarWrapper, {
        isModal: isModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hCroN.default), {
        isModal: isModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$Divider, {
        isModal: isModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 0,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 1,
        paddingBottom: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
        isModal: isModal,
        fontSize: 14,
        lineHeight: 16,
        intrusion: 250
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2xN2s.default), {
        isModal: isModal,
        paddingTop: 4,
        paddingBottom: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c75Wq.default), {
        isModal: isModal,
        fontSize: 24,
        lineHeight: 24,
        intrusion: 0
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$FillerMask, {
        isModal: isModal
    })));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6da0de659ae0ee53$export$2e2bcd8739ae039 = ()=>{
    const isModal = (0, $hJ992.useIsModal)();
    const isEmbedMode = (0, $keOMr.useIsEmbedMode)();
    const isLayered = isModal || isEmbedMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84CBi.default), {
        name: "activity-feed-skeleton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMstM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $6da0de659ae0ee53$var$activityItemSkeleton(isLayered)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6da0de659ae0ee53$var$FormContainer, {
        isModal: isLayered,
        paddingTop: 0,
        paddingBottom: 0
    }, $6da0de659ae0ee53$var$activityItemSkeleton(isLayered))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6da0de659ae0ee53$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $3o7jb.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$FormContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $2xN2s.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$Divider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iMstM.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbrdoj _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$FillerMask = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $iMstM.CleanDiv), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iqslr",
            __cmplp.className
        ])
    });
});
const $6da0de659ae0ee53$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1d0yzzt": (0, $9t7rW.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `${(0, $c9TLT.gridSize) * 4}px solid ${__cmplp.isModal ? "var(--ds-surface-overlay, white)" : "var(--ds-surface, white)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zl1vzo _4t3i1ylp _1o9zidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hCroN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fde01c2e11a41db1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $fde01c2e11a41db1$var$Avatar = ({ isModal: isModal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        focusable: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "circle-cutout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "18",
        cy: "18",
        r: "16",
        fill: "black"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "0",
        y: "0",
        width: "40",
        height: "40",
        mask: "url(#circle-cutout)",
        fill: isModal ? `var(--ds-surface-overlay, ${(0, $PdmhA).N0})` : `var(--ds-surface, ${(0, $PdmhA).N0})`
    }));
var $fde01c2e11a41db1$export$2e2bcd8739ae039 = $fde01c2e11a41db1$var$Avatar;

});

parcelRegister("2xN2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $4724dbf507794f29$export$2e2bcd8739ae039);
/* container-mask-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4724dbf507794f29$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, paddingTop: paddingTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1cgzp5c": (0, $9t7rW.default)(__cmplp.paddingTop, "px"),
            "--_1ntldin": (0, $9t7rW.default)(__cmplp.paddingBottom, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1bsb1osq",
            __cmplp.isModal ? "_x3doostm" : "_x3do3rsf",
            __cmplp.isModal ? "_n7zlfiih" : "_n7zlh1it",
            __cmplp.className
        ])
    });
});
var $4724dbf507794f29$export$2e2bcd8739ae039 = $4724dbf507794f29$var$SC1;

});

parcelRegister("iMstM", function(module, exports) {

$parcel$export(module.exports, "CleanDiv", () => $ac9f216c767cd799$export$e2099645cdcaf24c);
$parcel$export(module.exports, "default", () => $ac9f216c767cd799$export$2e2bcd8739ae039);
/* skeleton-background-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $ac9f216c767cd799$var$shimmer = null;
const $ac9f216c767cd799$export$e2099645cdcaf24c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1itkglyw",
            __cmplp.isModal ? "_bfhk1bhr" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $ac9f216c767cd799$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhk1yrq _1itkygre _12vemgnk _kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf",
            __cmplp.className
        ])
    });
});
var $ac9f216c767cd799$export$2e2bcd8739ae039 = $ac9f216c767cd799$var$SC1;

});

parcelRegister("3o7jb", function(module, exports) {

$parcel$export(module.exports, "default", () => $93316a0a0a2c434d$export$2e2bcd8739ae039);
/* skeleton-container-view.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $93316a0a0a2c434d$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _kqswh2mm",
            __cmplp.className
        ])
    });
});
var $93316a0a0a2c434d$export$2e2bcd8739ae039 = $93316a0a0a2c434d$var$SC1;

});

parcelRegister("c75Wq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7c0f40bfd895f01$export$2e2bcd8739ae039);
/* text-line-mask-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d7c0f40bfd895f01$var$SC1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isModal: isModal, intrusion: intrusion, lineHeight: lineHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1sswcfi": (0, $9t7rW.default)(`${__cmplp.fontSize}px`),
            "--_172l934": (0, $9t7rW.default)(__cmplp.intrusion, "px"),
            "--_1o6j0d": (0, $9t7rW.default)((__cmplp.lineHeight - __cmplp.fontSize) / 2, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1l57",
            __cmplp.isModal ? "_1s7z12nn" : "_1s7z1cpt",
            __cmplp.isModal ? "_x3do12pv" : "_x3do16rq",
            __cmplp.isModal ? "_n7zl12pv" : "_n7zl16rq",
            __cmplp.className
        ])
    });
});
var $d7c0f40bfd895f01$export$2e2bcd8739ae039 = $d7c0f40bfd895f01$var$SC1;

});

parcelRegister("keOMr", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedMode", () => $e37727bc1c1720b6$export$1b3c1ba6ee047da9);

var $eUqFw = parcelRequire("eUqFw");

var $sFzm1 = parcelRequire("sFzm1");

var $sFzm1 = parcelRequire("sFzm1");
const $e37727bc1c1720b6$export$1b3c1ba6ee047da9 = ()=>(0, $eUqFw.useContext)((0, $sFzm1.EmbedModeContext));

});


parcelRegister("djQa4", function(module, exports) {

$parcel$export(module.exports, "Emphasise", () => $43ac64dedb7ab423$export$e37ce51e697da8bf);
$parcel$export(module.exports, "GridContainer", () => $43ac64dedb7ab423$export$cc55614734af2d87);
$parcel$export(module.exports, "FeedContainer", () => $43ac64dedb7ab423$export$80ab5be5aa0a54ea);
$parcel$export(module.exports, "AdditionalHeaderContentPermalinkContainer", () => $43ac64dedb7ab423$export$b2b5c2b3066bf175);
$parcel$export(module.exports, "GridContentContainer", () => $43ac64dedb7ab423$export$61ddb209b0ea5e1);
$parcel$export(module.exports, "ActivityTimestampStyles", () => $43ac64dedb7ab423$export$b633a13c56e91288);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $43ac64dedb7ab423$export$e37ce51e697da8bf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$e37ce51e697da8bf.displayName = 'Emphasise';
const $43ac64dedb7ab423$export$cc55614734af2d87 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _18u01b66 _o5721q9c",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$cc55614734af2d87.displayName = 'GridContainer';
const $43ac64dedb7ab423$export$80ab5be5aa0a54ea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8gx6n",
            __cmplp.className
        ])
    });
});
const $43ac64dedb7ab423$export$d1ac28722bca370e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$d1ac28722bca370e.displayName = 'TimestampContainer';
const $43ac64dedb7ab423$export$b2b5c2b3066bf175 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0r5cr _1e0c11p5",
            __cmplp.className
        ])
    });
});
const $43ac64dedb7ab423$export$61ddb209b0ea5e1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5",
            __cmplp.className
        ])
    });
});
$43ac64dedb7ab423$export$61ddb209b0ea5e1.displayName = 'GridContentContainer';
const $43ac64dedb7ab423$export$b633a13c56e91288 = {
    // @ts-expect-error - TS2322 - Type 'InterpolationValue[]' is not assignable to type 'string'.
    always: (0, $kwce8.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${(0, $PdmhA).N500})`
    }),
    // @ts-expect-error - TS2322 -Type 'InterpolationValue[]' is not assignable to type 'string'.
    whenDisplaySettingSwitchable: (0, $kwce8.css)({
        '&:hover': {
            color: 'inherit'
        }
    })
};

});

parcelRegister("gW4YY", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c41a8288d89a1b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $eTy9x = parcelRequire("eTy9x");

var $kdFiT = parcelRequire("kdFiT");

var $OfOJM = parcelRequire("OfOJM");
const $74c41a8288d89a1b$export$53ac33307b5acee9 = (issueKey)=>({
        status: 'IDLE',
        issueKey: issueKey,
        historyItems: [],
        nextPageStartIndex: 0
    });
const $74c41a8288d89a1b$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case 'FETCH_PAGE_SUCCESS':
            // Result is stale if issue key changed in the meantime.
            if (action.issueKey !== state.issueKey) return state;
            return {
                ...state,
                status: 'IDLE',
                nextPageStartIndex: action.response.isLastPage ? null : action.response.nextPageStartIndex,
                historyItems: [
                    ...state.historyItems,
                    ...action.response.history
                ]
            };
        case 'FETCH_PAGE_FAILURE':
            // Result is stale if issue key changed in the meantime.
            if (action.issueKey !== state.issueKey) return state;
            return {
                ...state,
                status: 'ERROR'
            };
        case 'NEXT_PAGE_REQUESTED':
            return {
                ...state,
                status: 'LOADING_SUBSEQUENT_PAGE'
            };
        case 'CHANGE_ISSUE_REQUESTED':
            return {
                issueKey: action.issueKey,
                status: 'LOADING_FIRST_PAGE',
                historyItems: [],
                nextPageStartIndex: 0
            };
        default:
            // prettier-ignore
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            action.type;
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unknown action type in issue history reducer: ${action.type}`);
    }
};
const $74c41a8288d89a1b$export$3343632372cec89d = (baseUrl, issueKey, sortOrder)=>{
    const [state, dispatch] = (0, $eUqFw.useReducer)($74c41a8288d89a1b$export$1650419e431d3ba3, $74c41a8288d89a1b$export$53ac33307b5acee9(issueKey));
    const fetchPage = (0, $eUqFw.useCallback)(async (pageStartIndex, pageSize)=>{
        try {
            const response = await (0, $kdFiT.getIssueHistory)(baseUrl, issueKey, pageStartIndex, sortOrder, pageSize);
            dispatch({
                type: 'FETCH_PAGE_SUCCESS',
                response: response,
                issueKey: issueKey
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.activity.history.fetch-history-page', 'Query returned errors', error);
            dispatch({
                type: 'FETCH_PAGE_FAILURE',
                issueKey: issueKey
            });
        }
    }, [
        baseUrl,
        issueKey,
        sortOrder
    ]);
    (0, $eUqFw.useEffect)(()=>{
        dispatch({
            type: 'CHANGE_ISSUE_REQUESTED',
            issueKey: issueKey
        });
        fetchPage(0, (0, $eTy9x.NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS));
    }, [
        fetchPage,
        issueKey
    ]);
    const loadMore = ()=>{
        const { status: status, nextPageStartIndex: nextPageStartIndex } = state;
        if (status === 'IDLE' && nextPageStartIndex !== null) {
            dispatch({
                type: 'NEXT_PAGE_REQUESTED'
            });
            fetchPage(nextPageStartIndex, (0, $eTy9x.NUM_PAGED_ITEMS_TO_LOAD));
        }
    };
    const { status: status, historyItems: historyItems, nextPageStartIndex: nextPageStartIndex } = state;
    return {
        loading: status === 'LOADING_FIRST_PAGE',
        loadingMore: status === 'LOADING_SUBSEQUENT_PAGE',
        error: status === 'ERROR',
        hasMore: nextPageStartIndex !== null,
        data: (0, $OfOJM.groupHistoryItems)(historyItems),
        loadMore: loadMore
    };
};
const $74c41a8288d89a1b$var$IssueHistoryService = ({ baseUrl: baseUrl, issueKey: issueKey, sortOrder: sortOrder, children: children })=>children($74c41a8288d89a1b$export$3343632372cec89d(baseUrl, issueKey, sortOrder));
var $74c41a8288d89a1b$export$2e2bcd8739ae039 = $74c41a8288d89a1b$var$IssueHistoryService;

});
parcelRegister("eTy9x", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$724fbfb10c203824);
$parcel$export(module.exports, "NUM_INITIAL_ITEMS_TO_LOAD_FOR_POST_LOAD_ACTIONS", () => $0bfbe56dc89f06eb$export$a1162d3036fadf0e);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD", () => $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7);
$parcel$export(module.exports, "NUM_PAGED_ITEMS_TO_LOAD_OLD", () => $0bfbe56dc89f06eb$export$9b2f842ae6d3541d);
$parcel$export(module.exports, "LOAD_NEWER_BUTTON", () => $0bfbe56dc89f06eb$export$4f2e52b6b9be5088);
$parcel$export(module.exports, "LOAD_OLDER_BUTTON", () => $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0);
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles

var $c9TLT = parcelRequire("c9TLT");
const $0bfbe56dc89f06eb$export$724fbfb10c203824 = 5;
const $0bfbe56dc89f06eb$export$a1162d3036fadf0e = 100;
const $0bfbe56dc89f06eb$export$ed7e687bbd42b4a7 = 100;
const $0bfbe56dc89f06eb$export$9b2f842ae6d3541d = 10;
const $0bfbe56dc89f06eb$export$ef42ae71539e03a7 = `${3 * (0, $c9TLT.gridSize)}px`;
const $0bfbe56dc89f06eb$export$4f2e52b6b9be5088 = 'LOAD_NEWER_BUTTON';
const $0bfbe56dc89f06eb$export$ed33f944ab1a1bb0 = 'LOAD_OLDER_BUTTON';

});

parcelRegister("kdFiT", function(module, exports) {

$parcel$export(module.exports, "fetchIssueCreatedInfo", () => $3d986f25be9ff559$export$b071d2800a3c3856);
$parcel$export(module.exports, "getIssueHistory", () => $3d986f25be9ff559$export$efacec3410a85dc7);

var $lRmyA = parcelRequire("lRmyA");

var $kXzsJ = parcelRequire("kXzsJ");


var $eicMP = parcelRequire("eicMP");
const $3d986f25be9ff559$export$d245426099cf4980 = `
    query IssueHistoryQuery($issueKey: String!, $startAt: Long, $maxResults: Int, $orderBy: String) {
        viewIssue(issueKey: $issueKey) {
            history(orderBy: $orderBy, startAt: $startAt, maxResults: $maxResults) {
                isLast
                totalCount
                startIndex
                nodes {
                    fieldId
                    fieldType
                    fieldSchema {
                        type
                        customFieldType
                    }
                    timestamp
                    actor {
                        avatarUrls {
                            large
                        }
                        displayName
                        accountId
                    }
                    fieldDisplayName
                    from {
                        ... on GenericFieldValue {
                            displayValue
                            value
                        }
                        ... on AssigneeFieldValue {
                            displayValue
                            value
                            avatarUrl
                        }
                        ... on PriorityFieldValue {
                            displayValue
                            value
                            iconUrl
                        }
                        ... on StatusFieldValue {
                            displayValue
                            value
                            categoryId
                        }
                        ... on WorkLogFieldValue {
                            displayValue
                            value
                            worklog {
                                id
                                timeSpent
                            }
                        }
                        ... on RespondersFieldValue {
                            displayValue
                            value
                            responders {
                                ari
                                name
                                type
                                avatarUrl
                            }
                        }
                    }
                    to {
                        ... on GenericFieldValue {
                            displayValue
                            value
                        }
                        ... on AssigneeFieldValue {
                            displayValue
                            value
                            avatarUrl
                        }
                        ... on PriorityFieldValue {
                            displayValue
                            value
                            iconUrl
                        }
                        ... on StatusFieldValue {
                            displayValue
                            value
                            categoryId
                        }
                        ... on WorkLogFieldValue {
                            displayValue
                            value
                            worklog {
                                id
                                timeSpent
                            }
                        }
                        ... on RespondersFieldValue {
                            displayValue
                            value
                            responders {
                                ari
                                name
                                type
                                avatarUrl
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $3d986f25be9ff559$var$getIssueCreatedUrl = (baseUrl, issueKey)=>`${baseUrl}/rest/api/3/issue/${issueKey}?fields=creator,created`;
const $3d986f25be9ff559$export$b071d2800a3c3856 = (baseUrl, issueKey)=>(0, $lRmyA.performGetRequest)($3d986f25be9ff559$var$getIssueCreatedUrl(baseUrl, issueKey)).then((0, $eicMP.transformCreateInfoResponse));
const $3d986f25be9ff559$export$23a326979994188b = async (baseUrl, issueKey, startAt, sortMode, pageSize)=>{
    const client = (0, $kXzsJ.getClient)(baseUrl);
    // @ts-expect-error - Property 'data' does not exist on type 'unknown'. | Property 'errors' does not exist on type 'unknown'.
    const { data: data, errors: errors } = await client.query({
        query: $3d986f25be9ff559$export$d245426099cf4980,
        variables: {
            issueKey: issueKey,
            startAt: startAt,
            maxResults: pageSize,
            orderBy: sortMode === (0, $25476979aca7c7e0$export$e86669f498228fff) ? 'created' : '-created'
        }
    });
    if (errors) throw new Error(`Errors returned from IssueHistoryQuery result: ${errors// @ts-expect-error - TS7006 - Parameter 'x' implicitly has an 'any' type.
    .map((x)=>x.message).join(', ')}`);
    if (!data) throw new Error('Unexpected empty data object received from IssueHistoryQuery result with no errors');
    return (0, $eicMP.transformGraphQlResponse)(data, pageSize);
};
const $3d986f25be9ff559$export$efacec3410a85dc7 = async (baseUrl, issueKey, startAt, sortMode, pageSize)=>{
    if (startAt === 0 && sortMode === (0, $25476979aca7c7e0$export$e86669f498228fff)) {
        const [issueHistory, createInfo] = await Promise.all([
            $3d986f25be9ff559$export$23a326979994188b(baseUrl, issueKey, startAt, sortMode, pageSize),
            $3d986f25be9ff559$export$b071d2800a3c3856(baseUrl, issueKey)
        ]);
        return {
            ...issueHistory,
            history: [
                createInfo,
                ...issueHistory.history
            ]
        };
    }
    const issueHistory = await $3d986f25be9ff559$export$23a326979994188b(baseUrl, issueKey, startAt, sortMode, pageSize);
    if (sortMode === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) && issueHistory.isLastPage) {
        const createInfo = await $3d986f25be9ff559$export$b071d2800a3c3856(baseUrl, issueKey);
        return {
            ...issueHistory,
            history: [
                ...issueHistory.history,
                createInfo
            ]
        };
    }
    return issueHistory;
};

});
// Activity sort order
const $25476979aca7c7e0$export$eda5fe8da1abb04c = 'NEWEST_FIRST';
const $25476979aca7c7e0$export$e86669f498228fff = 'OLDEST_FIRST';

parcelRegister("eicMP", function(module, exports) {

$parcel$export(module.exports, "transformChangelogItem", () => $88f54d46ff47fd6d$export$a32d3e40a269588f);
$parcel$export(module.exports, "transformCreateInfoResponse", () => $88f54d46ff47fd6d$export$5135eb3afa736a29);
$parcel$export(module.exports, "transformGraphQlResponse", () => $88f54d46ff47fd6d$export$716425a07890b235);

var $8blac = parcelRequire("8blac");

var $3xcI8 = parcelRequire("3xcI8");

var $kyEKc = parcelRequire("kyEKc");

var $8Qd0L = parcelRequire("8Qd0L");

var $79xbN = parcelRequire("79xbN");

var $lO4Or = parcelRequire("lO4Or");

const $88f54d46ff47fd6d$var$transformRestActor = (actor)=>actor ? {
        avatarUrl: actor.avatarUrls['48x48'],
        displayName: actor.displayName,
        accountId: actor.accountId
    } : null;
const $88f54d46ff47fd6d$var$transformGraphQlActor = (actor)=>actor ? {
        avatarUrl: actor.avatarUrls.large,
        displayName: actor.displayName,
        accountId: actor.accountId
    } : null;
const $88f54d46ff47fd6d$export$a32d3e40a269588f = (item)=>{
    const { fieldSchema: fieldSchema, fieldId: fieldId, fieldType: fieldType, fieldDisplayName: fieldDisplayName, timestamp: changelogTimestamp, actor: changelogActor } = item;
    // so we don't need `if (from)...` on every branch
    let { from: from, to: to } = item;
    // @ts-expect-error - TS2322 - Type 'FieldValueGraphQlResponse | {}' is not assignable to type 'FieldValueGraphQlResponse | null | undefined'.
    from = from || {};
    // @ts-expect-error - TS2322 - Type 'FieldValueGraphQlResponse | {}' is not assignable to type 'FieldValueGraphQlResponse | undefined'.
    to = to || {};
    const actor = $88f54d46ff47fd6d$var$transformGraphQlActor(changelogActor);
    const timestamp = typeof changelogTimestamp === 'string' ? (0, $3xcI8.default)(changelogTimestamp) : (0, $kyEKc.default)(changelogTimestamp);
    if ((fieldType === 'jira' && fieldId === 'description' || fieldType === 'custom' && fieldSchema?.customFieldType === (0, $lO4Or.TEXT_AREA_CF_TYPE)) && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return {
        fieldType: fieldType,
        type: (0, $1455c4053b160137$export$771d231cdd66c0e2),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from?.displayValue,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        toValue: to?.displayValue
    };
    if (fieldType === 'jira' && fieldId === 'assignee') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$f1970b3f16b29de5),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2322 - Type '{ displayName: string | null; avatarUrl: string | undefined; accountId: string | undefined; } | null' is not assignable to type 'User | null'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromUser: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(from.displayValue) ? {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            displayName: from.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            avatarUrl: from.avatarUrl,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            accountId: from.accountId
        } : null,
        // @ts-expect-error - TS2322 - Type '{ displayName: string | null; avatarUrl: string | undefined; accountId: string | undefined; } | null' is not assignable to type 'User | null'. | TS2532 - Object is possibly 'undefined'.
        toUser: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(to.displayValue) ? {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            displayName: to.displayValue,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            avatarUrl: to.avatarUrl,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            accountId: to.accountId
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'status') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$7566709b8f78aeb1),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2322 - Type '{ name: string | null; statusCategory: StatusCategory; } | null' is not assignable to type 'Status | null'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromStatus: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(from.displayValue) ? {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            name: from.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            statusCategory: (0, $8Qd0L.statusCategoryForId)(from.categoryId)
        } : null,
        // @ts-expect-error - TS2322 - Type '{ name: string | null; statusCategory: StatusCategory; } | null' is not assignable to type 'Status | null'. | TS2532 - Object is possibly 'undefined'.
        toStatus: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(to.displayValue) ? {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            name: to.displayValue,
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            statusCategory: (0, $8Qd0L.statusCategoryForId)(to.categoryId)
        } : null
    };
    if (fieldType === 'jira' && fieldId === 'comment') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$53e9822dbffbb9bc),
        actor: actor,
        timestamp: timestamp
    };
    if (fieldType === 'jira' && fieldId === 'softArchived') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$5fd7b626c41a75e3),
        actor: actor,
        timestamp: timestamp,
        fromValue: from?.value
    };
    if (fieldType === 'jira' && fieldId === 'attachment') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$107cfebb0511df9e),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2532 - Object is possibly 'undefined'.
        filename: from.displayValue ?? to.displayValue ?? '',
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        action: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(from.displayValue) ? (0, $1455c4053b160137$export$4427798ee4002a4d) : (0, $1455c4053b160137$export$8648a9c7bbb05a59)
    };
    if (fieldType === 'jira' && fieldId === 'priority') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$e0672bc3e33c4c82),
        actor: actor,
        timestamp: timestamp,
        fromPriority: {
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            iconUrl: from.iconUrl || '',
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            name: from.displayValue || ''
        },
        toPriority: {
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            iconUrl: to.iconUrl || '',
            // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
            name: to.displayValue || ''
        }
    };
    // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    if (fieldType === 'jira' && fieldDisplayName === 'WorklogId' && to.worklog) return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$33b21ab9c6fec8d0),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        comment: to.worklog.comment,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        timeSpent: to.worklog.timeSpent
    };
    if (fieldType === 'jira' && fieldDisplayName === 'IssueParentAssociation') return {
        fieldType: fieldType,
        type: (0, $1455c4053b160137$export$edaa98b0c4bb1ef3),
        actor: actor,
        timestamp: timestamp,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.displayValue,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.displayValue
    };
    if (fieldType === 'jira' && (fieldId === 'timespent' || fieldId === 'timeestimate' || fieldId === 'timeoriginalestimate')) return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$37c97aab53f01e4c),
        actor: actor,
        field: fieldDisplayName,
        timestamp: timestamp,
        timeTrackingConfig: item.timeTrackingConfig ? item.timeTrackingConfig : null,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        fromTime: parseInt(from.value, 10),
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        toTime: parseInt(to.value, 10)
    };
    if (fieldType === 'custom' && fieldSchema && fieldSchema.customFieldType === 'com.atlassian.jira.plugin.system.customfieldtypes:float') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$b45ef25f7a696e98),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'. | TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(from.displayValue) ? Number(from.displayValue) : null,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
        toValue: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(to.displayValue) ? Number(to.displayValue) : null
    };
    if ((fieldType === 'jira' || fieldType === 'custom') && fieldSchema && fieldSchema.type === 'date' || fieldType === 'custom' && fieldSchema && fieldSchema.type === 'datetime') // handles the default due date and custom date/datetime fields for the history log.
    return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$ccf54e923acb91b2),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromDate: from.value,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toDate: to.value,
        fieldSchema: fieldSchema.type
    };
    if (fieldType === 'custom' && fieldSchema?.customFieldType === (0, $lO4Or.RESPONDERS_CF_TYPE)) return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$69a77f5e7c42a227),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.responders || null,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.responders || null
    };
    if (fieldType === 'custom' && fieldSchema?.customFieldType === (0, $lO4Or.SERVICE_ENTITY_CF_TYPE)) return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$bf9ba14f4fe0e36a),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        fromValue: from?.value || null,
        toValue: to?.value || null,
        fromDisplayValue: from?.displayValue || null,
        toDisplayValue: to?.displayValue || null
    };
    if (fieldType === 'jira' && fieldId === 'dataClassification') return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$844d56dab10d6cfb),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        fromClassification: from?.displayValue ? {
            name: from?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            color: from?.color,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            guidelines: from?.guidelines
        } : null,
        toClassification: to?.displayValue ? {
            name: to?.displayValue,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            color: to?.color,
            // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
            guidelines: to?.guidelines
        } : null
    };
    return {
        fieldType: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? fieldType : undefined,
        type: (0, $1455c4053b160137$export$f567ac9d3526e5ce),
        actor: actor,
        timestamp: timestamp,
        field: fieldDisplayName,
        // @ts-expect-error - TS2533 - Object is possibly 'null' or 'undefined'.
        fromValue: from.displayValue,
        // @ts-expect-error - TS2532 - Object is possibly 'undefined'.
        toValue: to.displayValue
    };
};
const $88f54d46ff47fd6d$export$5135eb3afa736a29 = ({ fields: { created: created, creator: creator } })=>({
        fieldType: 'jira',
        type: (0, $1455c4053b160137$export$91de1ada4d2d3ca6),
        actor: $88f54d46ff47fd6d$var$transformRestActor(creator),
        timestamp: (0, $3xcI8.default)(created)
    });
const $88f54d46ff47fd6d$export$716425a07890b235 = (data, maxResults)=>({
        nextPageStartIndex: data.viewIssue.history.isLast ? 0 : data.viewIssue.history.startIndex + maxResults,
        isLastPage: data.viewIssue.history.isLast,
        history: data.viewIssue.history.nodes.map($88f54d46ff47fd6d$export$a32d3e40a269588f)
    });

});
const $1455c4053b160137$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $1455c4053b160137$export$f1970b3f16b29de5 = 'ASSIGNEE_CHANGED';
const $1455c4053b160137$export$7566709b8f78aeb1 = 'STATUS_CHANGED';
const $1455c4053b160137$export$53e9822dbffbb9bc = 'COMMENT_CHANGED';
const $1455c4053b160137$export$5fd7b626c41a75e3 = 'ARCHIVED_CHANGED';
const $1455c4053b160137$export$107cfebb0511df9e = 'ATTACHMENT_CHANGED';
const $1455c4053b160137$export$e0672bc3e33c4c82 = 'PRIORITY_CHANGED';
const $1455c4053b160137$export$e5cb2c6d5fff1f58 = 'FLAG_CHANGED';
const $1455c4053b160137$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $1455c4053b160137$export$b45ef25f7a696e98 = 'NUMERIC_FIELD_CHANGED';
const $1455c4053b160137$export$771d231cdd66c0e2 = 'RICH_TEXT_FIELD_CHANGED';
const $1455c4053b160137$export$91de1ada4d2d3ca6 = 'ISSUE_CREATED';
const $1455c4053b160137$export$33b21ab9c6fec8d0 = 'WORK_LOGGED';
const $1455c4053b160137$export$37c97aab53f01e4c = 'TIME_CHANGED';
const $1455c4053b160137$export$edaa98b0c4bb1ef3 = 'PARENT_ISSUE_CHANGED';
const $1455c4053b160137$export$ccf54e923acb91b2 = 'DATE_ISSUE_CHANGED';
const $1455c4053b160137$export$69a77f5e7c42a227 = 'RESPONDERS_CHANGED';
const $1455c4053b160137$export$bf9ba14f4fe0e36a = 'AFFECTED_SERVICES_CHANGED';
const $1455c4053b160137$export$33f8a9cb608132ba = 'Responders';
const $1455c4053b160137$export$5e56d79dfe9be3d = 'Affected services';
const $1455c4053b160137$export$a3171a3a7d9e1e5b = 'team';
const $1455c4053b160137$export$1187c3553ecd80a1 = 'user';
const $1455c4053b160137$export$844d56dab10d6cfb = 'DATA_CLASSIFICATION_CHANGED';
const $1455c4053b160137$export$8648a9c7bbb05a59 = 'ATTACHMENT_UPLOADED';
const $1455c4053b160137$export$4427798ee4002a4d = 'ATTACHMENT_DELETED';
const $1455c4053b160137$export$75936e876282682b = 'FLAG_ADDED';
const $1455c4053b160137$export$cc84d15d1f34510d = 'FLAG_REMOVED';



parcelRegister("OfOJM", function(module, exports) {

$parcel$export(module.exports, "groupHistoryItems", () => $7eddb14c7e14c386$export$5502f38a1909b15b);

var $hompL = parcelRequire("hompL");

var $79xbN = parcelRequire("79xbN");

const $7eddb14c7e14c386$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $7eddb14c7e14c386$var$TIME_BATCH = 5;
const $7eddb14c7e14c386$var$isWithinTimeBatch = (item, lastItem)=>Math.abs(lastItem.timestamp.getTime() - item.timestamp.getTime()) / 60000 <= $7eddb14c7e14c386$var$TIME_BATCH;
const $7eddb14c7e14c386$var$isDescendingOrder = (firstItem, lastItem)=>firstItem.timestamp > lastItem.timestamp;
const $7eddb14c7e14c386$export$5502f38a1909b15b = (items)=>{
    if (!(0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return items;
    if (!items.length) return [];
    const itemsMap = new Map();
    const orderIsDescending = $7eddb14c7e14c386$var$isDescendingOrder(items[0], items[items.length - 1]);
    items.forEach((item)=>{
        if (item.type === (0, $1455c4053b160137$export$91de1ada4d2d3ca6)) {
            // we don't want to group this entry, so setting the item's id (not actor's id) as a key to disable potential further grouping
            itemsMap.set((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), item);
            return;
        }
        const actor = item.actor;
        const currentItem = itemsMap.get(actor?.accountId);
        if (!currentItem) {
            if (actor?.accountId) itemsMap.set(actor.accountId, item);
        } else {
            const isAlreadyGrouped = currentItem.type === $7eddb14c7e14c386$var$HISTORY_GROUPED_ITEMS_CATEGORY;
            if ($7eddb14c7e14c386$var$isWithinTimeBatch(item, currentItem)) {
                if (isAlreadyGrouped) currentItem.items.push(item);
                else itemsMap.set(actor?.accountId, {
                    type: $7eddb14c7e14c386$var$HISTORY_GROUPED_ITEMS_CATEGORY,
                    timestamp: currentItem.timestamp,
                    actor: currentItem.actor,
                    items: [
                        currentItem,
                        item
                    ]
                });
            } else {
                // don't need to be grouped, so setting the random id as a key to disable potential further grouping
                itemsMap.set((0, (/*@__PURE__*/$parcel$interopDefault($hompL)))(), currentItem);
                itemsMap.set(actor?.accountId, item);
            }
        }
    });
    const sortedByTimeItems = Array.from(itemsMap.values()).sort((a, b)=>{
        if (orderIsDescending) return b.timestamp.getTime() - a.timestamp.getTime();
        return a.timestamp.getTime() - b.timestamp.getTime();
    });
    return sortedByTimeItems;
};

});


parcelRegister("7SwYz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce4b6fd9897ac7b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $bKxX9 = parcelRequire("bKxX9");

var $4ksts = parcelRequire("4ksts");

var $hJ992 = parcelRequire("hJ992");


var $7slI5 = parcelRequire("7slI5");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hgkcz = parcelRequire("hgkcz");

var $5saHl = parcelRequire("5saHl");
const $6ce4b6fd9897ac7b$var$HISTORY_GROUPED_ITEMS_CATEGORY = 'HISTORY';
const $6ce4b6fd9897ac7b$export$1b027679229955ad = ({ formatMessage: formatMessage, isLoadingMore: isLoadingMore, onLoadMore: onLoadMore, sortOrder: sortOrder })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const prevIsLoadingMore = (0, $eUqFw.useRef)(isLoadingMore);
    (0, $eUqFw.useEffect)(()=>{
        prevIsLoadingMore.current = isLoadingMore;
    }, [
        isLoadingMore
    ]);
    const onLoadMoreButtonClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'loadMoreButtonClicked', {
            loadMoreButtonTypeClicked: sortOrder === (0, $25476979aca7c7e0$export$eda5fe8da1abb04c) ? 'LOAD_OLDER_BUTTON' : 'LOAD_NEWER_BUTTON'
        });
        onLoadMore();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7slI5.default), {
        shouldFitContainer: true,
        isDisabled: isLoadingMore,
        isLoading: isLoadingMore,
        onClick: onLoadMoreButtonClick
    }, formatMessage((0, $5saHl.default).loadMore));
};
const $6ce4b6fd9897ac7b$export$222853952f102f7d = 'history_activity_repeat_usage_cache_value';
const $6ce4b6fd9897ac7b$var$HistoryItems = ({ history: history, isLoadingMore: isLoadingMore, onLoadMore: onLoadMore, hasMore: hasMore, sortOrder: sortOrder, GroupedActivityEntryComponent: GroupedActivityEntry })=>{
    const intl = (0, $4ksts.useIntlV2)();
    // To be cleaned up when activity experiment closes: jira-issue-view-activity-feed-syntax-value-updates: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/issue_view_activity_timeline/setup
    const issueKey = (0, $hJ992.useIssueKey)();
    let isRepeatedUseOfHistoryActivityFeedAcrossIssues = false;
    (0, $eUqFw.useMemo)(()=>{
        if ((0, $bKxX9.ff)('jira-issue-view-activity-feed-temp-metrics_hpdjz')) {
            const issueKeyFromStorage = window.localStorage?.getItem($6ce4b6fd9897ac7b$export$222853952f102f7d);
            if (issueKeyFromStorage) {
                if (issueKeyFromStorage !== issueKey) // eslint-disable-next-line react-hooks/exhaustive-deps
                isRepeatedUseOfHistoryActivityFeedAcrossIssues = true;
            } else window.localStorage.setItem($6ce4b6fd9897ac7b$export$222853952f102f7d, issueKey);
        }
    }, []);
    // if (!GroupedActivityEntry && fg('issue_view_activity_timeline_targeting_gate_')) {
    // 	// @todo: fire analytic error here
    // }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "historyItems",
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, history.map((historyItem, index)=>historyItem?.type === $6ce4b6fd9897ac7b$var$HISTORY_GROUPED_ITEMS_CATEGORY && GroupedActivityEntry && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(GroupedActivityEntry, {
            key: index,
            item: historyItem
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgkcz.default), {
            key: index,
            historyItem: historyItem
        })), hasMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "issue-history.ui.history-items.load-more-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ce4b6fd9897ac7b$export$1b027679229955ad, {
        formatMessage: intl.formatMessage,
        isLoadingMore: isLoadingMore,
        onLoadMore: onLoadMore,
        sortOrder: sortOrder
    })), // To be cleaned up when activity experiment closes: jira-issue-view-activity-feed-syntax-value-updates: https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/issue_view_activity_timeline/setup
    (0, $bKxX9.ff)('jira-issue-view-activity-feed-temp-metrics_hpdjz') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            isRepeatedUseOfHistoryActivityFeedAcrossIssues: isRepeatedUseOfHistoryActivityFeedAcrossIssues
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
var $6ce4b6fd9897ac7b$export$2e2bcd8739ae039 = $6ce4b6fd9897ac7b$var$HistoryItems;

});
parcelRegister("7slI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d64055f6527778f4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $4Bees = parcelRequire("4Bees");
// Mimics the new `isLoading` prop in @atlaskit/button@7.x. This component can
// be deleted when we upgrade to the latest version of @atlaskit/button.
const $d64055f6527778f4$var$Button = (props)=>{
    const { children: children, isDisabled: isDisabled, isLoading: isLoading, onClick: onClick, shouldFitContainer: shouldFitContainer } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClick,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
        iconAfter: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }) : null,
        shouldFitContainer: shouldFitContainer
    }, !isLoading ? children : null);
};
var $d64055f6527778f4$export$2e2bcd8739ae039 = $d64055f6527778f4$var$Button;

});

// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("hgkcz", function(module, exports) {

$parcel$export(module.exports, "default", () => $bde5a3088198d7ff$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $1MVxl = parcelRequire("1MVxl");

var $l8M38 = parcelRequire("l8M38");

var $7ezvi = parcelRequire("7ezvi");

var $37MLq = parcelRequire("37MLq");

var $cdxhU = parcelRequire("cdxhU");

var $e7l8Y = parcelRequire("e7l8Y");

var $m4ES5 = parcelRequire("m4ES5");

var $i0pIQ = parcelRequire("i0pIQ");

var $f33F6 = parcelRequire("f33F6");

var $99NbK = parcelRequire("99NbK");

var $8DRiG = parcelRequire("8DRiG");

var $ln6zv = parcelRequire("ln6zv");

var $9En2x = parcelRequire("9En2x");

var $3cuBF = parcelRequire("3cuBF");

var $hVngm = parcelRequire("hVngm");

var $5euWl = parcelRequire("5euWl");

var $e9ota = parcelRequire("e9ota");

var $akKru = parcelRequire("akKru");
const $bde5a3088198d7ff$var$HistoryItemComponent = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const activityTimelineWorklogProps = (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? {
        showTimestamp: true,
        showPermalink: false
    } : {};
    switch(historyItem.type){
        case 0, $1455c4053b160137$export$f1970b3f16b29de5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ezvi.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$7566709b8f78aeb1:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e9ota.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$53e9822dbffbb9bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cdxhU.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$5fd7b626c41a75e3:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l8M38.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$107cfebb0511df9e:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $37MLq.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$e0672bc3e33c4c82:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9En2x.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$e5cb2c6d5fff1f58:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i0pIQ.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$91de1ada4d2d3ca6:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99NbK.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$f567ac9d3526e5ce:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f33F6.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$771d231cdd66c0e2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hVngm.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$b45ef25f7a696e98:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DRiG.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$37c97aab53f01e4c:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5euWl.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$33b21ab9c6fec8d0:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $akKru.default), {
                historyItem: historyItem,
                isGrouped: isGrouped,
                ...activityTimelineWorklogProps
            });
        case 0, $1455c4053b160137$export$edaa98b0c4bb1ef3:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ln6zv.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$ccf54e923acb91b2:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $m4ES5.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$69a77f5e7c42a227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3cuBF.default), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$bf9ba14f4fe0e36a:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MVxl.AffectedServicesHistoryItem), {
                historyItem: historyItem,
                isGrouped: isGrouped
            });
        case 0, $1455c4053b160137$export$844d56dab10d6cfb:
            return (0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7l8Y.DataClassificationHistoryItem), {
                historyItem: historyItem,
                isGrouped: isGrouped
            }) : null;
        default:
            return null;
    }
};
var $bde5a3088198d7ff$export$2e2bcd8739ae039 = $bde5a3088198d7ff$var$HistoryItemComponent;

});
parcelRegister("1MVxl", function(module, exports) {

$parcel$export(module.exports, "AffectedServicesHistoryItem", () => $29a1c361099e7eea$export$be5d249d7e924d4f);

var $eUqFw = parcelRequire("eUqFw");

var $g28pH = parcelRequire("g28pH");

var $kbWsT = parcelRequire("kbWsT");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $5yIww = parcelRequire("5yIww");

var $ZBola = parcelRequire("ZBola");
// Get services from display value which could be either service names 'name1, name2' or ARIs '[ari1, ari2]'.
const $29a1c361099e7eea$var$getServicesFromDisplayValue = (value, displayValue)=>{
    if (displayValue === null) return [];
    if (value === null) {
        let trimmedDisplayValue = (0, (/*@__PURE__*/$parcel$interopDefault($kbWsT)))(displayValue, '[');
        trimmedDisplayValue = (0, (/*@__PURE__*/$parcel$interopDefault($g28pH)))(trimmedDisplayValue, ']');
        return trimmedDisplayValue.split(', ').filter((name)=>name);
    }
    return displayValue.split(', ').filter((name)=>name);
};
const $29a1c361099e7eea$export$be5d249d7e924d4f = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { actor: actor, timestamp: timestamp, fromValue: fromValue, toValue: toValue, fromDisplayValue: fromDisplayValue, toDisplayValue: toDisplayValue } = historyItem;
    const fromServices = $29a1c361099e7eea$var$getServicesFromDisplayValue(fromValue, fromDisplayValue);
    const toServices = $29a1c361099e7eea$var$getServicesFromDisplayValue(toValue, toDisplayValue);
    const actionMessage = fromServices.length > toServices.length ? (0, $5yIww.default).removed : (0, $5yIww.default).added;
    const action = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...actionMessage,
        values: {
            services: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), null, formatMessage((0, $5yIww.default).affectedServices))
        }
    });
    return isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
        field: formatMessage((0, $5yIww.default).affectedServices),
        from: fromServices.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZBola.ServicesList), {
            services: fromServices
        }) : null,
        to: toServices.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZBola.ServicesList), {
            services: toServices
        }) : null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
        actor: actor,
        action: action,
        timestamp: timestamp,
        change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
            from: fromServices.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZBola.ServicesList), {
                services: fromServices
            }) : null,
            to: toServices.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ZBola.ServicesList), {
                services: toServices
            }) : null
        })
    });
};

});
parcelRegister("g28pH", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $8SGvQ = parcelRequire("8SGvQ");

var $1qE1i = parcelRequire("1qE1i");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");

var $4tf2Z = parcelRequire("4tf2Z");
/**
 * Removes trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimEnd('  abc  ');
 * // => '  abc'
 *
 * _.trimEnd('-_-abc-_-', '_-');
 * // => '-_-abc'
 */ function $030326a515a7dc42$var$trimEnd(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return string.slice(0, $4tf2Z(string) + 1);
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), end = $1qE1i(strSymbols, $aSldm(chars)) + 1;
    return $8SGvQ(strSymbols, 0, end).join('');
}
module.exports = $030326a515a7dc42$var$trimEnd;

});

parcelRegister("kbWsT", function(module, exports) {

var $TLr3n = parcelRequire("TLr3n");

var $8SGvQ = parcelRequire("8SGvQ");

var $3Muqa = parcelRequire("3Muqa");

var $aSldm = parcelRequire("aSldm");

var $1uqnh = parcelRequire("1uqnh");
/** Used to match leading whitespace. */ var $eb322fac8ad5c15b$var$reTrimStart = /^\s+/;
/**
 * Removes leading whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trimStart('  abc  ');
 * // => 'abc  '
 *
 * _.trimStart('-_-abc-_-', '_-');
 * // => 'abc-_-'
 */ function $eb322fac8ad5c15b$var$trimStart(string, chars, guard) {
    string = $1uqnh(string);
    if (string && (guard || chars === undefined)) return string.replace($eb322fac8ad5c15b$var$reTrimStart, '');
    if (!string || !(chars = $TLr3n(chars))) return string;
    var strSymbols = $aSldm(string), start = $3Muqa(strSymbols, $aSldm(chars));
    return $8SGvQ(strSymbols, start).join('');
}
module.exports = $eb322fac8ad5c15b$var$trimStart;

});

parcelRegister("jVbrS", function(module, exports) {

$parcel$export(module.exports, "Subtle", () => $2f832ef55bdee8fe$export$e08a60472c492df4);
$parcel$export(module.exports, "default", () => $2f832ef55bdee8fe$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4ksts = parcelRequire("4ksts");

var $6Kuhf = parcelRequire("6Kuhf");
const $2f832ef55bdee8fe$var$Value = ({ value: value, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f832ef55bdee8fe$export$4dc9f58ad9a1a000, null, value || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f832ef55bdee8fe$export$e08a60472c492df4, null, intl.formatMessage((0, $6Kuhf.default).none)));
const $2f832ef55bdee8fe$var$Change = ({ from: from, to: to })=>{
    const intl = (0, $4ksts.useIntlV2)();
    return from || to ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f832ef55bdee8fe$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f832ef55bdee8fe$var$Value, {
        value: from,
        intl: intl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f832ef55bdee8fe$export$21b07c8f274aebd5, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2f832ef55bdee8fe$var$Value, {
        value: to,
        intl: intl
    })) : null;
};
var $2f832ef55bdee8fe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $2f832ef55bdee8fe$var$Change;
const $2f832ef55bdee8fe$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pku2gc _syazjjyb _1i4qfg65",
            __cmplp.className
        ])
    });
});
$2f832ef55bdee8fe$export$42a852a2b6b56249.displayName = 'Container'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $2f832ef55bdee8fe$export$e08a60472c492df4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
$2f832ef55bdee8fe$export$e08a60472c492df4.displayName = 'Subtle';
const $2f832ef55bdee8fe$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8h8dc _cfu11ule _1kt9bjq5",
            __cmplp.className
        ])
    });
});
$2f832ef55bdee8fe$export$21b07c8f274aebd5.displayName = 'Arrow';
const $2f832ef55bdee8fe$export$4dc9f58ad9a1a000 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _p12f1ssb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6Kuhf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b85b22f88bbf64$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b0b85b22f88bbf64$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-history.common.change.none",
        "defaultMessage": "None"
    }
});

});


parcelRegister("k4aVr", function(module, exports) {

$parcel$export(module.exports, "ValueContainer", () => $f6513c0f025887c9$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "default", () => $f6513c0f025887c9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4ksts = parcelRequire("4ksts");

var $1g98m = parcelRequire("1g98m");
const $f6513c0f025887c9$var$Value = ({ value: value, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$4dc9f58ad9a1a000, null, value || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$e08a60472c492df4, null, intl.formatMessage((0, $1g98m.default).none)));
const $f6513c0f025887c9$var$InlineValue = ({ value: value, intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$9c8a180f83a74105, null, value || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$e08a60472c492df4, null, intl.formatMessage((0, $1g98m.default).none)));
const $f6513c0f025887c9$var$FieldValue = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$16cca812ebc2f6de, null, value);
const $f6513c0f025887c9$var$GroupedChange = ({ field: field, from: from, to: to, isRichTextField: isRichTextField = false })=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isRichTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$28ad03e8947ff882, null, field !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$var$FieldValue, {
        value: field
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$var$InlineValue, {
        value: to,
        intl: intl
    })), !isRichTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$42a852a2b6b56249, null, field !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$var$FieldValue, {
        value: field
    }), from !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$var$Value, {
        value: from,
        intl: intl
    }), from !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$export$21b07c8f274aebd5, null), to !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6513c0f025887c9$var$Value, {
        value: to,
        intl: intl
    })));
};
var $f6513c0f025887c9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $f6513c0f025887c9$var$GroupedChange;
const $f6513c0f025887c9$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19pku2gc _syazjjyb _1i4qfg65",
            __cmplp.className
        ])
    });
});
const $f6513c0f025887c9$export$28ad03e8947ff882 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _syazjjyb",
            __cmplp.className
        ])
    });
});
$f6513c0f025887c9$export$42a852a2b6b56249.displayName = 'Container';
const $f6513c0f025887c9$export$e08a60472c492df4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
$f6513c0f025887c9$export$e08a60472c492df4.displayName = 'Subtle';
const $f6513c0f025887c9$export$21b07c8f274aebd5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8h8dc _cfu11ule _1kt9bjq5",
            __cmplp.className
        ])
    });
});
$f6513c0f025887c9$export$21b07c8f274aebd5.displayName = 'Arrow';
const $f6513c0f025887c9$export$4dc9f58ad9a1a000 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _p12f1ssb",
            __cmplp.className
        ])
    });
});
const $f6513c0f025887c9$export$9c8a180f83a74105 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt",
            __cmplp.className
        ])
    });
});
const $f6513c0f025887c9$export$16cca812ebc2f6de = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1gjq _k48pu8c7 _2hwxu2gc _1wyb1a4x",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1g98m", function(module, exports) {

$parcel$export(module.exports, "default", () => $70df3c41679cb670$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $70df3c41679cb670$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-history.common.grouped-change.none",
        "defaultMessage": "None"
    }
});

});


parcelRegister("53f0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5a1a2bde637bfb3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $ffiyv = parcelRequire("ffiyv");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4iC3C = parcelRequire("4iC3C");

var $djQa4 = parcelRequire("djQa4");

var $kpn8k = parcelRequire("kpn8k");

var $2hhAC = parcelRequire("2hhAC");

var $j8Dnl = parcelRequire("j8Dnl");
const $f5a1a2bde637bfb3$var$renderActorNameWithProfileCard = (actor, intl, testId)=>{
    if (actor === null) return intl.formatMessage((0, $j8Dnl.default).anonymousUser);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpn8k.default), {
        userAccount: actor,
        analyticsData: {
            trigger: 'history-item-actor-name'
        },
        testId: `${testId}--name-trigger-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), null, actor?.displayName)));
};
const $f5a1a2bde637bfb3$var$HistoryItem = ({ action: action, change: change, actor: actor, timestamp: timestamp, testId: testId })=>{
    const intl = (0, $5JgJ2.default)();
    const [{ showLozenge: showLozenge }] = (0, $2hhAC.useIssueHistoryUi)();
    const HistoryItemComponentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$ContainerOld, {
        "data-testid": testId || 'history-item-without-test-id'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpn8k.default), {
        userAccount: actor,
        analyticsData: {
            trigger: 'history-item-actor-avatar'
        },
        testId: `${testId}--avatar-trigger-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$AvatarContainerOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "medium",
        src: actor ? actor.avatarUrl : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$ContentOld, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$Summary, null, $f5a1a2bde637bfb3$var$renderActorNameWithProfileCard(actor, intl, testId), " ", action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$TimestampContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iC3C.default), {
        value: timestamp.getTime(),
        extraStyles: (0, $djQa4.ActivityTimestampStyles),
        tooltipPosition: "top"
    })), showLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$LozengeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "issue-history.common.ui.history-item.lozenge"
    }, intl.formatMessage((0, $j8Dnl.default).lozenge)))), change));
    const HistoryItemComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$Container, {
        "data-testid": testId || 'history-item-without-test-id'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kpn8k.default), {
        userAccount: actor,
        analyticsData: {
            trigger: 'history-item-actor-avatar'
        },
        testId: `${testId}--avatar-trigger-container`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        src: actor ? actor.avatarUrl : undefined
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$Summary, null, $f5a1a2bde637bfb3$var$renderActorNameWithProfileCard(actor, intl, testId), " ", action, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5a1a2bde637bfb3$var$TimestampContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iC3C.default), {
        value: timestamp.getTime(),
        extraStyles: (0, $djQa4.ActivityTimestampStyles),
        tooltipPosition: "top"
    }))), change));
    return (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? HistoryItemComponent : HistoryItemComponentOld;
};
var $f5a1a2bde637bfb3$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f5a1a2bde637bfb3$var$HistoryItem;
const $f5a1a2bde637bfb3$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y",
            __cmplp.className
        ])
    });
});
const $f5a1a2bde637bfb3$var$ContainerOld = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81niu _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $f5a1a2bde637bfb3$var$Container = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8tvx8 _1e0c1txw",
            __cmplp.className
        ])
    });
});
$f5a1a2bde637bfb3$var$Container.displayName = 'Container';
const $f5a1a2bde637bfb3$var$AvatarContainerOld = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i14no _2hwxu2gc _1bsb14no _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $f5a1a2bde637bfb3$var$AvatarContainer = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _2hwxu2gc _1bsb1f4h _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
$f5a1a2bde637bfb3$var$AvatarContainer.displayName = 'Avatar';
const $f5a1a2bde637bfb3$var$ContentOld = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1wpz1h6o _1bsb2mt8",
            __cmplp.className
        ])
    });
});
const $f5a1a2bde637bfb3$var$Content = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1wpz1h6o _1bsb2mt8 _ca0q1b66",
            __cmplp.className
        ])
    });
});
$f5a1a2bde637bfb3$var$Content.displayName = 'Content'; // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a1a2bde637bfb3$var$Summary = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
$f5a1a2bde637bfb3$var$Summary.displayName = 'Summary'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a1a2bde637bfb3$var$TimestampContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
$f5a1a2bde637bfb3$var$TimestampContainer.displayName = 'TimestampContainer'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5a1a2bde637bfb3$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _18u0utpp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kpn8k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c2341632da5aee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aK7xv = parcelRequire("aK7xv");

var $94r7i = parcelRequire("94r7i");

var $2NwGr = parcelRequire("2NwGr");
const $e4c2341632da5aee$var$WithProfileCardNext = (props)=>{
    const accountId = (0, $aK7xv.mapExternalUserToAccountId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.userAccount);
    const fullName = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $94r7i.mapExternalUserToFullName)(props.userAccount);
    const renderAsyncProfileCardWrapper = (accountIdInArgs)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2NwGr.AsyncProfileCardNext), {
            accountId: accountIdInArgs,
            analyticsData: props.analyticsData,
            position: props.position,
            actions: props.actions,
            testId: props.testId,
            prepopulatedData: {
                fullName: fullName
            }
        }, props.children);
    return accountId ? renderAsyncProfileCardWrapper(accountId) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children);
};
var $e4c2341632da5aee$export$2e2bcd8739ae039 = $e4c2341632da5aee$var$WithProfileCardNext;

});
parcelRegister("aK7xv", function(module, exports) {

$parcel$export(module.exports, "mapExternalUserToAccountId", () => $1917fb93a2bbd593$export$4983762135761fa5);
const $1917fb93a2bbd593$export$4983762135761fa5 = (userAccount)=>userAccount && (userAccount.accountId || userAccount.id || userAccount.value);

});

parcelRegister("94r7i", function(module, exports) {

$parcel$export(module.exports, "mapExternalUserToFullName", () => $9b886aa43f58b774$export$41cd9a762b532c74);
const $9b886aa43f58b774$export$41cd9a762b532c74 = (userAccount)=>userAccount && (userAccount?.displayName || userAccount?.name);

});

parcelRegister("2NwGr", function(module, exports) {

$parcel$export(module.exports, "AsyncProfileCardNext", () => $d91bacdeb64d663f$export$a3c0845f856d4292);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $1lXFP = parcelRequire("1lXFP");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $d91bacdeb64d663f$var$LazyComponent = (0, $7rh0R.lazy)(()=>(parcelRequire("41OLy")).then((module)=>module.ProfileCard), {
    moduleId: "./src/packages/profilecard-next/src/main.tsx"
});
const $d91bacdeb64d663f$export$a3c0845f856d4292 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncProfileCardNext",
        packageName: "jiraProfilecardNext",
        render: ()=>// props.children in this context is the code being wrapped
            // in a <ProfileCardTrigger> (I.e. it is the thing a user hovers over to
            // display a profile card).
            // In the event of an unexpected error within @atlaskit/profilecard,
            // just render the unwrapped children (I.e. they will render but nothing
            // happens on hover)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children),
        sendToPrivacyUnsafeSplunk: true,
        teamName: "empanada",
        attributes: (0, $1lXFP.isLoaderErrorAttributes)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-profile-card-next-view",
        fallback: props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d91bacdeb64d663f$var$LazyComponent, props)));
var $d91bacdeb64d663f$export$2e2bcd8739ae039 = $d91bacdeb64d663f$export$a3c0845f856d4292;

});
parcelRegister("1lXFP", function(module, exports) {

$parcel$export(module.exports, "isLoaderErrorAttributes", () => $1c31f74fac112a78$export$c7209ce2e0d060ea);

var $7rh0R = parcelRequire("7rh0R");
const $1c31f74fac112a78$export$c7209ce2e0d060ea = (error)=>({
        isLoaderError: (0, $7rh0R.isLoaderError)(error)
    });

});

// values which are passed into the tracking callback by atlaskit
const $2f37035f7aaf1787$export$febebefae5a09065 = 'profile-card.loaded';
const $2f37035f7aaf1787$export$3ca1936ee743bd18 = 'profile-card.view';
const $2f37035f7aaf1787$export$25bd35f2cd9ae0ea = 'profile-card.reload';
const $2f37035f7aaf1787$export$86aa8b9c379ebbbd = 'profile-card.error';
const $2f37035f7aaf1787$export$4442e31da6ba4127 = 'profile-card.click';
const $2f37035f7aaf1787$export$7ecd9c56ca354ac0 = 'profileCardNext';
const $2f37035f7aaf1787$export$81319ffa9c0d18d7 = 'profileCardNext';
const $2f37035f7aaf1787$export$3145fc6c544ad7bf = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$50632e21ea714398 = 'profileCardNextLegacy';
const $2f37035f7aaf1787$export$d053e144c034c8aa = 'teamProfileCardNextLegacy';
const $2f37035f7aaf1787$export$2549357601611c61 = 'loadError';
const $2f37035f7aaf1787$export$23cedd3261bd8015 = 'viewProfile';
const $2f37035f7aaf1787$export$6bef782d14a92db8 = 'assignedIssues';
const $2f37035f7aaf1787$export$6b36f20db7a18a86 = 'reportedIssues';
const $2f37035f7aaf1787$export$56da0dd0b0aa67b9 = 'viewFilters';

parcelRegister("41OLy", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('keVAk')
        ]);
        const value = parcelRequire('12NzK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("keVAk")
    ]).then(()=>parcelRequire('12NzK'));
}

});



parcelRegister("2hhAC", function(module, exports) {

$parcel$export(module.exports, "useIssueHistoryUi", () => $946c9504fa8a8d45$export$3ad74fc9dcef1ee3);
$parcel$export(module.exports, "useIssueHistoryStoreActions", () => $946c9504fa8a8d45$export$a1cb9dfb24356cc6);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $39uZL = parcelRequire("39uZL");
const $946c9504fa8a8d45$export$d4c72bab9d6cc13a = {
    ui: {
        showLozenge: false
    }
};
const $946c9504fa8a8d45$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-history',
    initialState: $946c9504fa8a8d45$export$d4c72bab9d6cc13a,
    actions: $39uZL.actions
});
const $946c9504fa8a8d45$export$3ad74fc9dcef1ee3 = (0, $ggKAj.createHook)($946c9504fa8a8d45$export$6f57813fe9f31bf9, {
    selector: (state)=>state.ui
});
const $946c9504fa8a8d45$export$a1cb9dfb24356cc6 = (0, $ggKAj.createHook)($946c9504fa8a8d45$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("39uZL", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a0e3dc83b1a31e8d$export$e324594224ef24da);
const $a0e3dc83b1a31e8d$var$mergeUiState = (ui)=>({ setState: setState, getState: getState })=>{
        const previousUiState = getState().ui;
        const newState = {
            ...getState(),
            ui: {
                ...previousUiState,
                ...ui
            }
        };
        setState(newState);
    };
const $a0e3dc83b1a31e8d$export$e324594224ef24da = {
    mergeUiState: $a0e3dc83b1a31e8d$var$mergeUiState
};

});


parcelRegister("j8Dnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $689a91683cce0257$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $689a91683cce0257$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    anonymousUser: {
        "id": "issue-history.common.history-item.anonymous-user",
        "defaultMessage": "Anonymous user"
    },
    lozenge: {
        "id": "issue-history.common.history-item.lozenge",
        "defaultMessage": "History"
    }
});

});


parcelRegister("5yIww", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccf9648f41e249f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8ccf9648f41e249f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    affectedServices: {
        "id": "issue-history.history-items.history-item.affected-services-history-item.affected-services",
        "defaultMessage": "Affected services"
    },
    added: {
        "id": "issue-history.history-items.history-item.affected-services-history-item.added",
        "defaultMessage": "added {services}"
    },
    removed: {
        "id": "issue-history.history-items.history-item.affected-services-history-item.removed",
        "defaultMessage": "removed {services}"
    }
});

});

parcelRegister("ZBola", function(module, exports) {

$parcel$export(module.exports, "ServicesList", () => $b1706a7f03087d00$export$b595651d00cea82d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b1706a7f03087d00$export$b595651d00cea82d = ({ services: services })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1706a7f03087d00$var$ListWrapper, {
        "data-testid": "issue-history.ui.history-items.history-item.affected-services-history-item.services-list"
    }, services.map((serviceName)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1706a7f03087d00$var$Value, {
            "data-testid": "issue-history.ui.history-items.history-item.affected-services-history-item.services-list.value",
            key: serviceName
        }, serviceName)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1706a7f03087d00$var$ListWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $b1706a7f03087d00$var$Value = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _18s81b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("l8M38", function(module, exports) {

$parcel$export(module.exports, "default", () => $726244db132b2828$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $gCgob = parcelRequire("gCgob");
const $726244db132b2828$var$ArchivedHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, fromValue: fromValue } = historyItem;
    const isArchived = fromValue === 'false';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...isArchived ? (0, $gCgob.default).archived : (0, $gCgob.default).unarchived,
        values: {
            issue: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "issue"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $gCgob.default).issue))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage(isArchived ? (0, $gCgob.default).archived : (0, $gCgob.default).unarchived),
            from: null,
            to: null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            testId: "issue-history.ui.history-items.history-item.archived-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: null
        }));
};
var $726244db132b2828$export$2e2bcd8739ae039 = $726244db132b2828$var$ArchivedHistoryItem;

});
parcelRegister("gCgob", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2b2c82acc363358$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b2b2c82acc363358$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    archived: {
        "id": "issue-history.history-items.history-item.archived-history-item.archived",
        "defaultMessage": "archived the {issue}."
    },
    unarchived: {
        "id": "issue-history.history-items.history-item.archived-history-item.unarchived",
        "defaultMessage": "unarchived the {issue}."
    },
    issue: {
        "id": "issue-history.history-items.history-item.archived-history-item.issue",
        "defaultMessage": "Issue"
    }
});

});


parcelRegister("7ezvi", function(module, exports) {

$parcel$export(module.exports, "default", () => $97fcbf95c8696481$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $ekDOe = parcelRequire("ekDOe");

var $6QL3h = parcelRequire("6QL3h");
const $97fcbf95c8696481$var$AssigneeHistoryItem = ({ historyItem: historyItem, Assignee: Assignee, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, fromUser: fromUser, toUser: toUser } = historyItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $6QL3h.default).changed,
        values: {
            assignee: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "assignee"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $6QL3h.default).assigneeLowercase : (0, $6QL3h.default).assignee))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $6QL3h.default).assignee),
            from: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Assignee, {
                user: fromUser
            }),
            to: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Assignee, {
                user: toUser
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.assignee-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Assignee, {
                    user: fromUser
                }),
                to: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Assignee, {
                    user: toUser
                })
            })
        }));
};
$97fcbf95c8696481$var$AssigneeHistoryItem.defaultProps = {
    Assignee: (0, $ekDOe.default)
};
var $97fcbf95c8696481$export$2e2bcd8739ae039 = $97fcbf95c8696481$var$AssigneeHistoryItem;

});
parcelRegister("ekDOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5aa98296d439b1b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $79xbN = parcelRequire("79xbN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jVbrS = parcelRequire("jVbrS");

var $kB2W3 = parcelRequire("kB2W3");
const $f5aa98296d439b1b$var$Assignee = ({ user: user })=>{
    const intl = (0, $5JgJ2.default)();
    return user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5aa98296d439b1b$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5aa98296d439b1b$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? 'small' : 'medium',
        src: user.avatarUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f5aa98296d439b1b$var$DisplayName, null, user.displayName)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.Subtle), null, intl.formatMessage((0, $kB2W3.default).unassigned));
};
var $f5aa98296d439b1b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f5aa98296d439b1b$var$Assignee;
const $f5aa98296d439b1b$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f5aa98296d439b1b$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i14no _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $f5aa98296d439b1b$var$DisplayName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kB2W3", function(module, exports) {

$parcel$export(module.exports, "default", () => $327859cf002cad13$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $327859cf002cad13$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassigned: {
        "id": "issue-history.history-items.history-item.assignee-history-item.assignee.unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("6QL3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecd1375ea42d4740$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ecd1375ea42d4740$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changed: {
        "id": "issue-history.history-items.history-item.assignee-history-item.changed",
        "defaultMessage": "changed the {assignee}"
    },
    assignee: {
        "id": "issue-history.history-items.history-item.assignee-history-item.assignee",
        "defaultMessage": "Assignee"
    },
    assigneeLowercase: {
        "id": "issue-history.history-items.history-item.assignee-history-item.assignee-lowercase",
        "defaultMessage": "assignee"
    }
});

});


parcelRegister("37MLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c27f24106ba85e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Yimi = parcelRequire("1Yimi");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");


var $3hHZW = parcelRequire("3hHZW");
const $66c27f24106ba85e$var$AttachmentHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, filename: filename, action: action } = historyItem;
    const attachedMessage = (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $3hHZW.default).attached : (0, $3hHZW.default).uploaded;
    const deletedMessage = (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $3hHZW.default).deleted : (0, $3hHZW.default).deletedDeprecated;
    const attachmentMessage = (0, $eUqFw.useMemo)(()=>action === (0, $1455c4053b160137$export$8648a9c7bbb05a59) ? attachedMessage : deletedMessage, [
        action,
        attachedMessage,
        deletedMessage
    ]);
    const ChangeComponent = (0, $eUqFw.useCallback)(()=>{
        if ((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false)) return undefined;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
            from: action === (0, $1455c4053b160137$export$4427798ee4002a4d) ? filename : null,
            to: action === (0, $1455c4053b160137$export$8648a9c7bbb05a59) ? filename : null
        });
    }, [
        filename,
        action
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...attachmentMessage,
        values: {
            /**
     * remove the attachment message from the translation key when
     * cleaning up this gate: issue_view_activity_timeline
     * */ attachment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "attachment"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $3hHZW.default).attachmentLowercase : (0, $3hHZW.default).attachment)),
            filename: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                weight: "medium",
                key: "filename"
            }, filename)
        }
    }, (...actionText)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            to: actionText
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            testId: "issue-history.ui.history-items.history-item.attachment-history-item.history-item",
            actor: actor,
            action: actionText,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ChangeComponent, null)
        }));
};
var $66c27f24106ba85e$export$2e2bcd8739ae039 = $66c27f24106ba85e$var$AttachmentHistoryItem;

});
parcelRegister("3hHZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4919b36dacae569$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4919b36dacae569$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    /**
   * @deprecated use `attached` instead
   * This entry will be removed when cleaning up this gate:
   * issue_view_activity_timeline
   */ uploaded: {
        "id": "issue-history.history-items.history-item.attachment-history-item.uploaded",
        "defaultMessage": "added an {attachment}"
    },
    attached: {
        "id": "issue-history.history-items.history-item.attachment-history-item.attached",
        "defaultMessage": "attached {filename}"
    },
    deleted: {
        "id": "issue-history.history-items.history-item.attachment-history-item.deleted",
        "defaultMessage": "deleted {filename}"
    },
    /**
   * @deprecated use `deleted` instead
   * This entry will be removed when cleaning up this gate:
   * issue_view_activity_timeline
   */ deletedDeprecated: {
        "id": "issue-history.history-items.history-item.attachment-history-item.deleted-deprecated",
        "defaultMessage": "deleted an {attachment}"
    },
    /**
   * This entry will be removed when cleaning up this gate:
   * issue_view_activity_timeline
   */ attachment: {
        "id": "issue-history.history-items.history-item.attachment-history-item.attachment",
        "defaultMessage": "Attachment"
    },
    /**
   * This entry will be removed when cleaning up this gate:
   * issue_view_activity_timeline
   */ attachmentLowercase: {
        "id": "issue-history.history-items.history-item.attachment-history-item.attachment-lowercase",
        "defaultMessage": "attachment"
    }
});

});


parcelRegister("cdxhU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d0b11da5443a27f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $hbr83 = parcelRequire("hbr83");
const $8d0b11da5443a27f$var$CommentHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp } = historyItem;
    return(// TODO: Message is currently always "deleted a comment"
    // Do we need to handle other types of comment changes?
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $hbr83.default).deleted,
        values: {
            comment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "comment"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $hbr83.default).commentLowercase : (0, $hbr83.default).comment))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $hbr83.default).comment),
            from: null,
            to: null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ), {
            testId: "issue-history.ui.history-items.comment-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: null,
                to: null
            })
        })));
};
var $8d0b11da5443a27f$export$2e2bcd8739ae039 = $8d0b11da5443a27f$var$CommentHistoryItem;

});
parcelRegister("hbr83", function(module, exports) {

$parcel$export(module.exports, "default", () => $49b9e5e829be5c61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49b9e5e829be5c61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    deleted: {
        "id": "issue-history.history-items.history-item.comment-history-item.deleted",
        "defaultMessage": "deleted a {comment}"
    },
    comment: {
        "id": "issue-history.history-items.history-item.comment-history-item.comment",
        "defaultMessage": "Comment"
    },
    commentLowercase: {
        "id": "issue-history.history-items.history-item.comment-history-item.comment-lowercase",
        "defaultMessage": "comment"
    }
});

});


parcelRegister("e7l8Y", function(module, exports) {

$parcel$export(module.exports, "DataClassificationHistoryItem", () => $8170b463c6505086$export$63bfe9455ff6489b);

var $eUqFw = parcelRequire("eUqFw");

var $5m8Fp = parcelRequire("5m8Fp");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $eao0H = parcelRequire("eao0H");
const $8170b463c6505086$var$DataClassificationBadge = ({ classification: classification })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5m8Fp.default), {
        testId: "issue-history.ui.history-items.history-item.data-classification-history-item.data-classification-badge",
        name: classification.name,
        color: classification.color?.colorKey,
        guideline: classification.guidelines
    });
const $8170b463c6505086$export$63bfe9455ff6489b = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, timestamp: timestamp, fromClassification: fromClassification, toClassification: toClassification } = historyItem;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (!(0, $1ybV0.ff)('jira-issue-history-data-classification_mhyjw')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $eao0H.default).changed,
        values: {
            status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "dataClassificationLevel"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $eao0H.default).dataClassificationLevelLowercase : (0, $eao0H.default).dataClassificationLevel))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $eao0H.default).dataClassificationLevel),
            from: fromClassification ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8170b463c6505086$var$DataClassificationBadge, {
                classification: fromClassification
            }) : formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $eao0H.default).noClassificationLowercase : (0, $eao0H.default).noClassification),
            to: toClassification ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8170b463c6505086$var$DataClassificationBadge, {
                classification: toClassification
            }) : formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $eao0H.default).noClassificationLowercase : (0, $eao0H.default).noClassification)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            testId: "issue-history.ui.history-items.history-item.data-classification-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: fromClassification ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8170b463c6505086$var$DataClassificationBadge, {
                    classification: fromClassification
                }) : formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $eao0H.default).noClassificationLowercase : (0, $eao0H.default).noClassification),
                to: toClassification ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8170b463c6505086$var$DataClassificationBadge, {
                    classification: toClassification
                }) : formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $eao0H.default).noClassificationLowercase : (0, $eao0H.default).noClassification)
            })
        }));
};

});
parcelRegister("5m8Fp", function(module, exports) {

$parcel$export(module.exports, "default", () => $02f9ee8d73ef4cc6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4q38b = parcelRequire("4q38b");

var $8cU5f = parcelRequire("8cU5f");

var $0XD3F = parcelRequire("0XD3F");

var $cKu1r = parcelRequire("cKu1r");

var $fsAjL = parcelRequire("fsAjL");

var $kwRHy = parcelRequire("kwRHy");
const $02f9ee8d73ef4cc6$var$classificationViewContainerStyles = (0, $1ZAYh.xcss)({
    width: '330px'
});
function $02f9ee8d73ef4cc6$export$2e2bcd8739ae039({ testId: testId, name: name, tooltip: tooltip, tooltipPosition: tooltipPosition, color: color = 'GREY', iconSize: iconSize = 'small', guideline: guideline, isDisabled: isDisabled = false, isPopupDisabled: isPopupDisabled = false, isPopupOpenByDefault: isPopupOpenByDefault = false, getPopupStateControllers: getPopupStateControllers, popupZIndex: popupZIndex, guidelineRepresentation: guidelineRepresentation = 'PLAIN', onPopupShown: onPopupShown, onPopupClose: onPopupClose, onClick: onClick, renderPopupComponent: renderPopupComponent, popupLabel: popupLabel, popupTitleId: popupTitleId, popupRole: popupRole, popupPlacement: popupPlacement = 'bottom-start', shouldRenderToParent: shouldRenderToParent, isIconOnly: isIconOnlyProp = false }) {
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(isDisabled || isPopupDisabled ? false : isPopupOpenByDefault);
    if (getPopupStateControllers) {
        const getOpenState = ()=>isPopupOpen;
        const setOpenState = (isOpen)=>setIsPopupOpen(isOpen);
        getPopupStateControllers(getOpenState, setOpenState);
    }
    const isMissingName = !name || name.length === 0;
    const isIconOnly = isMissingName || isIconOnlyProp;
    const nameTruncated = (name ?? '').substring(0, (0, $cKu1r.nameMaxLength));
    const iconPx = iconSize === 'small' ? 14 : iconSize === 'medium' ? 18 : iconSize === 'large' ? 24 : iconSize === 'xlarge' ? 32 : iconSize === 'xxlarge' ? 40 : 14;
    const handleContainerClicked = ()=>{
        if (isPopupDisabled || isDisabled || isMissingName) return;
        if (onPopupShown) onPopupShown();
        setIsPopupOpen(!isPopupOpen);
    };
    const closePopup = ()=>{
        setIsPopupOpen(false);
    };
    const containerTagType = isPopupDisabled || isMissingName ? 'span' : 'button';
    const ContainerTag = containerTagType === 'span' ? (0, $kwRHy.ContainerSpan) : (0, $kwRHy.ContainerButton);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        label: popupLabel,
        titleId: popupTitleId,
        role: popupRole,
        shouldRenderToParent: shouldRenderToParent,
        placement: popupPlacement,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: isPopupOpen ? null : tooltip,
                hideTooltipOnClick: true,
                position: tooltipPosition
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContainerTag, {
                "data-testid": testId,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: isDisabled ? 'disabled' : '',
                disabledColorConfig: (0, $cKu1r.disabledColorConfig)[colorMode],
                colorsConfig: (0, $cKu1r.colorsConfig)[colorMode][color],
                isIconOnly: isIconOnly,
                isPopupDisabled: isPopupDisabled,
                ...triggerProps,
                ...containerTagType === 'button' ? {
                    disabled: isDisabled,
                    type: 'button'
                } : {},
                onClick: ()=>{
                    if (onClick) onClick();
                    handleContainerClicked();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fsAjL.ClassificationIcon), {
                width: iconPx,
                height: iconPx,
                isDisabled: isDisabled,
                color: (0, $cKu1r.colorsConfig)[colorMode][color].fontColor,
                disabledColorConfig: (0, $cKu1r.disabledColorConfig)[colorMode]
            }), !isIconOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwRHy.Name), {
                "data-testid": "data-classification-level-name"
            }, nameTruncated))),
        content: ()=>renderPopupComponent ? renderPopupComponent(closePopup) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                padding: "space.250",
                xcss: $02f9ee8d73ef4cc6$var$classificationViewContainerStyles,
                role: "dialog",
                "aria-labelledby": "data-classification-read-content-name",
                "aria-describedby": "data-classification-read-content-guideline",
                "aria-modal": "true"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0XD3F.ClassificationView), {
                name: name,
                guideline: guideline,
                guidelineRepresentation: guidelineRepresentation
            })),
        isOpen: isPopupOpen,
        onClose: ()=>{
            if (onPopupClose) onPopupClose();
            closePopup();
        },
        zIndex: popupZIndex
    });
}

});
parcelRegister("0XD3F", function(module, exports) {

$parcel$export(module.exports, "ClassificationView", () => $079d5a98863247fb$export$d413367b4cbb5577);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $7Y6sw = parcelRequire("7Y6sw");

var $4lTFP = parcelRequire("4lTFP");

var $cKu1r = parcelRequire("cKu1r");

var $joBf7 = parcelRequire("joBf7");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $079d5a98863247fb$var$Name = /*#__PURE__*/ (0, $joBf7.default)("h2", {
    target: "e4jhxqx1"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-heading-medium, ${(0, $4lTFP.fontFallback).heading.medium})`,
    color: "var(--ds-text, #172B4D)"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $079d5a98863247fb$var$Guideline = /*#__PURE__*/ (0, $joBf7.default)("p", {
    target: "e4jhxqx0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    color: "var(--ds-text, #172B4D)",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word'
});
const $079d5a98863247fb$export$d413367b4cbb5577 = ({ name: name, guideline: guideline, guidelineRepresentation: guidelineRepresentation = 'PLAIN' })=>{
    const nameTruncated = (name ?? '').substring(0, (0, $cKu1r.nameMaxLength));
    const guidelineTruncated = (guideline ?? '').substring(0, (0, $cKu1r.guidelineMaxLength));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, nameTruncated && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($079d5a98863247fb$var$Name, {
        id: "data-classification-read-content-name"
    }, nameTruncated), guideline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200"
    }, guidelineRepresentation === 'PLAIN' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($079d5a98863247fb$var$Guideline, {
        id: "data-classification-read-content-guideline"
    }, guidelineTruncated) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y6sw.default), {
        maxHeight: 200,
        truncated: true,
        document: JSON.parse(guideline)
    })));
};

});
parcelRegister("cKu1r", function(module, exports) {

$parcel$export(module.exports, "nameMaxLength", () => $4dd5a9bb37f49e2f$export$253bdad208569777);
$parcel$export(module.exports, "guidelineMaxLength", () => $4dd5a9bb37f49e2f$export$e1444e5b0a63d793);
$parcel$export(module.exports, "colorsConfig", () => $4dd5a9bb37f49e2f$export$fb2992e82b83582a);
$parcel$export(module.exports, "disabledColorConfig", () => $4dd5a9bb37f49e2f$export$9cdea53b8993b139);

var $3dpxL = parcelRequire("3dpxL");

var $5qKYu = parcelRequire("5qKYu");
const { formatMessage: $4dd5a9bb37f49e2f$var$formatMessage } = (0, $3dpxL.createIntl)({
    locale: 'en'
});
const $4dd5a9bb37f49e2f$export$89b67151eed9295a = {
    definition: $4dd5a9bb37f49e2f$var$formatMessage((0, $5qKYu.messages).noClassification),
    includeIcon: false
};
const $4dd5a9bb37f49e2f$export$253bdad208569777 = 50;
const $4dd5a9bb37f49e2f$export$cbc3cef853d1014b = 1000;
const $4dd5a9bb37f49e2f$export$e1444e5b0a63d793 = 1000;
const $4dd5a9bb37f49e2f$export$fb2992e82b83582a = {
    light: {
        YELLOW: {
            fontColor: '#693200',
            bgColor: '#FFF5D4',
            bgColorHovered: '#FFE48F',
            bgColorPressed: '#FFC716',
            bgColorFocused: '#FFF5D4'
        },
        ORANGE: {
            fontColor: '#3A2C1F',
            bgColor: '#FFC716',
            bgColorHovered: '#FCA700',
            bgColorPressed: '#FA8700',
            bgColorFocused: '#FCA700'
        },
        RED: {
            fontColor: '#AE2E24',
            bgColor: '#FFECEB',
            bgColorHovered: '#FFD5D2',
            bgColorPressed: '#FD9891',
            bgColorFocused: '#FFECEB'
        },
        RED_BOLD: {
            fontColor: '#FFFFFF',
            bgColor: '#C9372C',
            bgColorHovered: '#AE2E24',
            bgColorPressed: '#5D1F1A',
            bgColorFocused: '#C9372C'
        },
        PURPLE: {
            fontColor: '#352C63',
            bgColor: '#DFD8FD',
            bgColorHovered: '#B8ACF6',
            bgColorPressed: '#9F8FEF',
            bgColorFocused: '#DFD8FD'
        },
        BLUE: {
            fontColor: '#09326C',
            bgColor: '#CCE0FF',
            bgColorHovered: '#85B8FF',
            bgColorPressed: '#579DFF',
            bgColorFocused: '#CCE0FF'
        },
        TEAL: {
            fontColor: '#206A83',
            bgColor: '#E7F9FF',
            bgColorHovered: '#C6EDFB',
            bgColorPressed: '#9DD9EE',
            bgColorFocused: '#E7F9FF'
        },
        GREEN: {
            fontColor: '#164B35',
            bgColor: '#BAF3DB',
            bgColorHovered: '#7EE2B8',
            bgColorPressed: '#4BCE97',
            bgColorFocused: '#BAF3DB'
        },
        GREY: {
            fontColor: '#172B4D',
            bgColor: '#F1F2F4',
            bgColorHovered: '#DCDFE4',
            bgColorPressed: '#B3B9C4',
            bgColorFocused: '#F1F2F4'
        },
        LIME: {
            fontColor: '#4C6B1F',
            bgColor: '#EFFFD6',
            bgColorHovered: '#D3F1A7',
            bgColorPressed: '#B3DF72',
            bgColorFocused: '#EFFFD6'
        }
    },
    dark: {
        YELLOW: {
            fontColor: '#FFE48F',
            bgColor: '#3A2C1F',
            bgColorHovered: '#693200',
            bgColorPressed: '#9E4C00',
            bgColorFocused: '#3A2C1F'
        },
        ORANGE: {
            fontColor: '#3A2C1F',
            bgColor: '#FFC716',
            bgColorHovered: '#FCA700',
            bgColorPressed: '#FA8700',
            bgColorFocused: '#FCA700'
        },
        RED: {
            fontColor: '#FD9891',
            bgColor: '#42221F',
            bgColorHovered: '#5D1F1A',
            bgColorPressed: '#AE2E24',
            bgColorFocused: '#42221F'
        },
        RED_BOLD: {
            fontColor: '#1D2125',
            bgColor: '#F87168',
            bgColorHovered: '#FD9891',
            bgColorPressed: '#FFD5D2',
            bgColorFocused: '#F87168'
        },
        PURPLE: {
            fontColor: '#DFD8FD',
            bgColor: '#352C63',
            bgColorHovered: '#5E4DB2',
            bgColorPressed: '#6E5DC6',
            bgColorFocused: '#352C63'
        },
        BLUE: {
            fontColor: '#CCE0FF',
            bgColor: '#09326C',
            bgColorHovered: '#0055CC',
            bgColorPressed: '#0C66E4',
            bgColorFocused: '#09326C'
        },
        TEAL: {
            fontColor: '#9DD9EE',
            bgColor: '#1E3137',
            bgColorHovered: '#164555',
            bgColorPressed: '#206A83',
            bgColorFocused: '#1E3137'
        },
        GREEN: {
            fontColor: '#BAF3DB',
            bgColor: '#164B35',
            bgColorHovered: '#216E4E',
            bgColorPressed: '#1F845A',
            bgColorFocused: '#164B35'
        },
        GREY: {
            fontColor: '#B6C2CF',
            bgColor: '#2C333A',
            bgColorHovered: '#38414A',
            bgColorPressed: '#454F59',
            bgColorFocused: '#2C333A'
        },
        LIME: {
            fontColor: '#B3DF72',
            bgColor: '#28311B',
            bgColorHovered: '#37471F',
            bgColorPressed: '#4C6B1F',
            bgColorFocused: '#28311B'
        }
    }
};
const $4dd5a9bb37f49e2f$export$9cdea53b8993b139 = {
    light: {
        fontColor: '#091E42',
        bgColor: 'rgba(9, 30, 66, 0.03)'
    },
    dark: {
        fontColor: '#BFDBF847',
        bgColor: 'rgba(3, 4, 4, 0.26)'
    }
};

});
parcelRegister("5qKYu", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e652032dc515bcd8$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e652032dc515bcd8$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noClassification: {
        id: 'data-classification-level.no-classification',
        defaultMessage: 'No classification',
        description: 'Text for the no classification option'
    },
    classifyContent: {
        id: 'data-classification-level.edit-popup.classify-content',
        defaultMessage: 'Classify content',
        description: 'Text for the header of the edit popup'
    },
    selectClassification: {
        id: 'data-classification-level.edit-popup.select-classification',
        defaultMessage: 'Select classification',
        description: 'Text for the label of the select dropdown to select a classification'
    },
    updateButton: {
        id: 'data-classification-level.edit-popup.update-button',
        defaultMessage: 'Update',
        description: 'Text for the update button'
    },
    cancelButton: {
        id: 'data-classification-level.edit-popup.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button'
    },
    changeLevel: {
        id: 'data-classification-level.read-popup.change-level',
        defaultMessage: 'Change level',
        description: 'Text for the button that changes the level of the selected classification'
    }
});

});



parcelRegister("fsAjL", function(module, exports) {

$parcel$export(module.exports, "ClassificationIcon", () => $ce679ced24c345e9$export$d2e14829910b9b7d);

var $eUqFw = parcelRequire("eUqFw");

var $iKepO = parcelRequire("iKepO");
const $ce679ced24c345e9$export$d2e14829910b9b7d = ({ color: color, width: width, height: height, isDisabled: isDisabled, disabledColorConfig: disabledColorConfig })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKepO.SvgIcon), {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4507 3.24947C11.7778 3.0101 12.2222 3.0101 12.5493 3.24947L12.6384 3.3145C12.6966 3.35693 12.7816 3.41879 12.8885 3.49621C13.1022 3.6511 13.4029 3.8681 13.7503 4.1163C14.4471 4.61402 15.325 5.23208 16.066 5.72614C16.731 6.16948 17.5184 6.51497 18.1606 6.75285C18.4775 6.87022 18.75 6.95808 18.9416 7.01617C19.0373 7.04516 19.1124 7.06659 19.1622 7.08044C19.1871 7.08736 19.2057 7.09238 19.2174 7.09549L19.2296 7.09873L19.231 7.09909C19.6299 7.20149 19.9142 7.55408 19.9294 7.96562L19 7.99995C19.9294 7.96562 19.9294 7.96545 19.9294 7.96562L19.9294 7.96637L19.9296 7.97092L19.9299 7.9823L19.9311 8.02272C19.9321 8.05733 19.9332 8.10704 19.9342 8.17035C19.9362 8.29692 19.9376 8.47816 19.9354 8.70198C19.931 9.14881 19.912 9.76955 19.8537 10.4665C19.7402 11.8241 19.4681 13.609 18.7732 14.9323C18.0039 16.3974 16.3463 17.7569 15.0203 18.6963C14.3347 19.182 13.6935 19.5855 13.2239 19.8675C12.9887 20.0088 12.7955 20.1202 12.66 20.1969C12.5923 20.2353 12.5389 20.265 12.5018 20.2855L12.4586 20.3092L12.4467 20.3157L12.442 20.3182C12.4419 20.3183 12.4413 20.3186 12 19.4999C11.566 20.3224 11.5658 20.3224 11.5657 20.3223L11.5606 20.3196L11.5484 20.3131L11.5044 20.2895C11.4666 20.269 11.4121 20.2393 11.3429 20.201C11.2047 20.1243 11.0075 20.013 10.7676 19.8718C10.2886 19.5899 9.63465 19.1866 8.93632 18.701C7.58714 17.763 5.89843 16.4025 5.12645 14.9323C4.4427 13.6301 4.19878 11.8354 4.10698 10.4745C4.0597 9.77357 4.05069 9.14709 4.05342 8.69567C4.05479 8.46954 4.05911 8.28624 4.06316 8.15821C4.06518 8.09417 4.06714 8.04388 4.06863 8.00888L4.07046 7.96804L4.07102 7.95657L4.07125 7.95199C4.07126 7.95182 4.07129 7.95125 5.00001 7.99995L4.07129 7.95125C4.09257 7.54532 4.37502 7.20025 4.76872 7.09917C4.7687 7.09917 4.76873 7.09916 4.76872 7.09917L4.7704 7.09873L4.78263 7.09549C4.79429 7.09238 4.81288 7.08736 4.83779 7.08044C4.88765 7.06659 4.96271 7.04516 5.05838 7.01617C5.25004 6.95808 5.52252 6.87022 5.8394 6.75285C6.48161 6.51498 7.26895 6.16948 7.93395 5.72614C8.67504 5.23208 9.55289 4.61402 10.2497 4.1163C10.5971 3.8681 10.8978 3.6511 11.1115 3.49621C11.2184 3.41879 11.3034 3.35693 11.3616 3.3145L11.4507 3.24947ZM5.91345 8.69663C5.91343 8.70005 5.91341 8.70348 5.91339 8.70693C5.91086 9.12508 5.91927 9.70457 5.96277 10.3493C6.05251 11.6797 6.28352 13.135 6.77323 14.0676C7.31396 15.0974 8.65034 16.2369 9.99807 17.1739C10.6482 17.6258 11.2607 18.0038 11.7109 18.2687C11.8151 18.33 11.9104 18.3852 11.9951 18.4336C12.0763 18.3862 12.1671 18.3325 12.2662 18.273C12.7071 18.0082 13.3072 17.6304 13.9451 17.1786C15.2657 16.243 16.5831 15.1025 17.1264 14.0676C17.6371 13.0952 17.89 11.63 18.0002 10.3116C18.0534 9.67538 18.0711 9.10545 18.0754 8.69297C17.9096 8.63851 17.7202 8.57322 17.5146 8.49705C16.8069 8.23492 15.8693 7.83042 15.0343 7.27375C14.2679 6.7628 13.3706 6.13086 12.6692 5.62983C12.4167 5.44946 12.1886 5.2854 12 5.14916C11.8114 5.2854 11.5833 5.44946 11.3308 5.62983C10.6294 6.13086 9.73213 6.7628 8.9657 7.27375C8.1307 7.83042 7.19314 8.23492 6.48544 8.49705C6.27515 8.57494 6.08188 8.64144 5.91345 8.69663ZM12 19.4999L11.5657 20.3223C11.8399 20.467 12.1684 20.4657 12.4413 20.3186L12 19.4999Z",
        fill: isDisabled ? disabledColorConfig.fontColor : color
    }));
};

});
parcelRegister("iKepO", function(module, exports) {

$parcel$export(module.exports, "SvgIcon", () => $0aa6c20a5024ad63$export$dbcb8210e8a983ed);

var $joBf7 = parcelRequire("joBf7");
const $0aa6c20a5024ad63$export$dbcb8210e8a983ed = /*#__PURE__*/ (0, $joBf7.default)("svg", {
    target: "e11zn5bp0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minWidth: `${props.width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        minHeight: `${props.height}px`
    }));

});


parcelRegister("kwRHy", function(module, exports) {

$parcel$export(module.exports, "ContainerButton", () => $6646000d7b1a3ac4$export$d7dd774c852ad5aa);
$parcel$export(module.exports, "ContainerSpan", () => $6646000d7b1a3ac4$export$bbad7babde89ffdd);
$parcel$export(module.exports, "Name", () => $6646000d7b1a3ac4$export$c7bd411105e2dec3);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $4lTFP = parcelRequire("4lTFP");

var $joBf7 = parcelRequire("joBf7");
const $6646000d7b1a3ac4$export$d7dd774c852ad5aa = /*#__PURE__*/ (0, $joBf7.default)("button", {
    target: "ednvuq82"
})((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        width: 'auto',
        alignItems: 'center',
        padding: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
        border: 'none',
        borderRadius: "var(--ds-border-radius, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.colorsConfig.fontColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: props.colorsConfig.bgColor,
        cursor: 'pointer',
        outline: 0,
        transition: 'background 0.1s ease-out 0s',
        '&:focus-visible': {
            outline: `1px solid ${"var(--ds-border-focused, #388BFF)"}`,
            outlineOffset: "var(--ds-space-025, 2px)",
            background: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorFocused
        },
        '&:hover': {
            background: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorHovered
        },
        '&:active': {
            background: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            props.isPopupDisabled || props.isIconOnly ? props.colorsConfig.bgColor : props.colorsConfig.bgColorPressed
        },
        '&:disabled': {
            cursor: 'default',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.disabledColorConfig.fontColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: props.disabledColorConfig.bgColor
        }
    }));
const $6646000d7b1a3ac4$export$bbad7babde89ffdd = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "ednvuq81"
})((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        width: 'auto',
        alignItems: 'center',
        padding: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: props.colorsConfig.fontColor,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: props.colorsConfig.bgColor,
        userSelect: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: props.disabledColorConfig.fontColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            background: props.disabledColorConfig.bgColor
        }
    }));
const $6646000d7b1a3ac4$export$c7bd411105e2dec3 = /*#__PURE__*/ (0, $joBf7.default)("span", {
    target: "ednvuq80"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`,
    fontWeight: "var(--ds-font-weight-medium, 500)",
    marginLeft: "var(--ds-space-025, 2px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});


parcelRegister("eao0H", function(module, exports) {

$parcel$export(module.exports, "default", () => $d57a9408c2fc962f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d57a9408c2fc962f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changed: {
        "id": "issue-history.history-items.history-item.data-classification-history-item.changed",
        "defaultMessage": "changed the {status}"
    },
    dataClassificationLevel: {
        "id": "issue-history.history-items.history-item.data-classification-history-item.data-classification-level",
        "defaultMessage": "Classification level"
    },
    dataClassificationLevelLowercase: {
        "id": "issue-history.history-items.history-item.data-classification-history-item.data-classification-level-lowercase",
        "defaultMessage": "classification level"
    },
    noClassification: {
        "id": "issue-history.history-items.history-item.data-classification-history-item.no-classification",
        "defaultMessage": "No classification"
    },
    noClassificationLowercase: {
        "id": "issue-history.history-items.history-item.data-classification-history-item.no-classification-lowercase",
        "defaultMessage": "no classification"
    }
});

});


parcelRegister("m4ES5", function(module, exports) {

$parcel$export(module.exports, "default", () => $64abafc8a0ff91da$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $gUUjF = parcelRequire("gUUjF");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");

var $6v322 = parcelRequire("6v322");

var $djQa4 = parcelRequire("djQa4");

var $02bgH = parcelRequire("02bgH");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");
const $64abafc8a0ff91da$export$2b1d391cd05230fd = ()=>(0, $gUUjF.default);
const $64abafc8a0ff91da$export$adf4502303fbfb8a = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, field: field, fieldType: fieldType, timestamp: timestamp, fromDate: fromDate, toDate: toDate, fieldSchema: fieldSchema } = historyItem;
    const { formatDateTime: formatDateTime, formatDateOnly: formatDateOnly } = (0, $6v322.useDateTimeFormatter)();
    const formatDateOrDateTime = (0, $eUqFw.useCallback)((value)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(value)) return null;
        if (fieldSchema === 'datetime') return formatDateTime(value);
        if (fieldSchema === 'date') return formatDateOnly(value);
        $64abafc8a0ff91da$export$2b1d391cd05230fd().safeErrorWithoutCustomerData('issue.activity.history.datechangedhistoryitemview.formatdateordatetime', 'Unexpected fieldSchema when trying to format date time', {
            expected: "'date' or 'datetime'",
            recieved: fieldSchema
        });
        return value;
    }, [
        fieldSchema,
        formatDateOnly,
        formatDateTime
    ]);
    const normalizedField = fieldType === 'jira' ? field?.toLocaleLowerCase() : field;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $02bgH.default).updatedField,
        values: {
            field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "field"
            }, normalizedField)
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: normalizedField,
            from: formatDateOrDateTime(fromDate),
            to: formatDateOrDateTime(toDate)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ), {
            testId: "issue-history.ui.history-items.date-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: formatDateOrDateTime(fromDate),
                to: formatDateOrDateTime(toDate)
            })
        }));
};
var $64abafc8a0ff91da$export$2e2bcd8739ae039 = $64abafc8a0ff91da$export$adf4502303fbfb8a;

});
parcelRegister("6v322", function(module, exports) {

$parcel$export(module.exports, "useDateTimeFormatter", () => $446d9deeb4d90baf$export$163f492669f74d5b);

var $eUqFw = parcelRequire("eUqFw");

var $asu8X = parcelRequire("asu8X");

var $cWiVr = parcelRequire("cWiVr");

var $4xHig = parcelRequire("4xHig");

var $lR5a1 = parcelRequire("lR5a1");

var $eHw0J = parcelRequire("eHw0J");
const $446d9deeb4d90baf$export$163f492669f74d5b = (overrideTimeZone)=>{
    (0, $asu8X.di)(Intl);
    const { data: { // @ts-expect-error - TS2339 - Property 'timeZone' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
    user: { timeZone: timeZonePreference } } } = (0, $cWiVr.useCurrentUser)();
    const timeZone = overrideTimeZone ?? timeZonePreference;
    const jiraLocal = (0, $4xHig.useLocale)();
    const standardizedLocale = (0, $eHw0J.standardizeLocale)(jiraLocal);
    const verifiedTimeZone = (0, $eHw0J.verifyTimeZone)(timeZone);
    const dateTimeFormatter = (0, $eUqFw.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $lR5a1.longDateTimeFormat),
            timeZone: verifiedTimeZone
        }), [
        standardizedLocale,
        verifiedTimeZone
    ]);
    const dateOnlyFormatter = (0, $eUqFw.useMemo)(()=>new Intl.DateTimeFormat(standardizedLocale, {
            ...(0, $lR5a1.longDateOnlyFormat),
            timeZone: 'UTC'
        }), [
        standardizedLocale
    ]);
    const formatDateTime = (0, $eUqFw.useCallback)((date)=>{
        const rawValue = typeof date === 'string' ? new Date(date) : date;
        return dateTimeFormatter.format(rawValue);
    }, [
        dateTimeFormatter
    ]);
    const formatDateOnly = (0, $eUqFw.useCallback)((date)=>dateOnlyFormatter.format(new Date(date)), [
        dateOnlyFormatter
    ]);
    return {
        formatDateTime: /**
		 * Returns the long form of a date value with respect to the user's locale and timezone preferences
		 *
		 * @param {string|number|date} date Value as either an [ISO8601 string](https://www.w3.org/TR/NOTE-datetime) (eg `"1997-07-16T19:20:30.45+01:00"`), epoch number (eg `1615431020`), or vanilla `Date` object
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021, 1:11 PM
		 * formatDateTime(1611281490857) // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日 午後1:11
		 * formatDateTime(1611281490857) // where user locale is "ja-JP"
		 * ```
		 */ formatDateTime,
        formatDateOnly: /**
		 * Returns the long form of a date without time value with respect to the user's locale. Timezones do not apply to these dates.
		 *
		 * @param {string} date Value as a 'YYYY-MM-DD' string (eg `"1997-07-16"`)
		 *
		 * ## Examples
		 *
		 * ```js
		 * // returns Jan 22, 2021
		 * formatDateOnly('2021-01-22') // where user locale is "en-US"
		 *
		 * // returns 2021年1月22日
		 * formatDateOnly('2021-01-22') // where user locale is "ja-JP"
		 * ```
		 */ formatDateOnly
    };
};

});
parcelRegister("lR5a1", function(module, exports) {

$parcel$export(module.exports, "longDateTimeFormat", () => $a517eed2e8954534$export$f2f390060309965);
$parcel$export(module.exports, "longDateOnlyFormat", () => $a517eed2e8954534$export$51f819d50bcd4ae1);
/**
 * If this file gets changed, please update platform/packages/proforma/proforma-common-core/src/form-system/components/questions/common/defaultDateTimeFormats.tsx or let the owners know via #jsm-request-intake.
 *
 * Proforma wants to stay consistent with Jira date and time format options.
 *
 * Later on Proforma will introduce React Context to pass config props, and this will be removed.
 */ /**
 * Long format of a date time, eg "Jun 16, 1971, 2:34 AM" with 12h/24h formatting resolved from locale
 */ const $a517eed2e8954534$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
};
const $a517eed2e8954534$export$51f819d50bcd4ae1 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
};

});

parcelRegister("eHw0J", function(module, exports) {

$parcel$export(module.exports, "standardizeLocale", () => $74eaa3a8d4b2e848$export$ca06804549ae25fb);
$parcel$export(module.exports, "verifyTimeZone", () => $74eaa3a8d4b2e848$export$93ff13646da25bd);

var $ao0hp = parcelRequire("ao0hp");

var $gUUjF = parcelRequire("gUUjF");
const $74eaa3a8d4b2e848$export$95b7602913551865 = 'en-US';
const $74eaa3a8d4b2e848$export$ca06804549ae25fb = (jiraLocale)=>{
    if (typeof jiraLocale !== 'string') {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jira-issue-format-date.standardize-locale', `Invalid input type for locale was passed in: ${jiraLocale}. Falling back to ${$74eaa3a8d4b2e848$export$95b7602913551865}.`);
        return $74eaa3a8d4b2e848$export$95b7602913551865;
    }
    const standardizedLocale = jiraLocale.replace('_', '-');
    switch(standardizedLocale){
        case 'en':
            return 'en-US';
        case 'en-UK':
            return 'en-GB';
        default:
            if (!(0, $ao0hp.default).includes(jiraLocale)) (0, $gUUjF.default).safeWarnWithoutCustomerData('jira-issue-format-date.standardize-locale', `Discovered unsupported locale: ${jiraLocale}. This value was not modified, but its use may lead to unpredictable behaviour for formatting.`);
            return standardizedLocale;
    }
};
const $74eaa3a8d4b2e848$export$93ff13646da25bd = (timeZone)=>{
    try {
        Intl.DateTimeFormat($74eaa3a8d4b2e848$export$95b7602913551865, {
            timeZone: timeZone
        });
        return timeZone;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jira-issue-format-date.verify-time-zone', `Invalid timeZone: ${String(timeZone)}. Date time formatting cannot be performed with this value. Falling back to undefined`, error);
        return undefined;
    }
};

});


parcelRegister("02bgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $744fd81f14e3efe8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $744fd81f14e3efe8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    updatedField: {
        "id": "issue-history.common.updated-field",
        "defaultMessage": "updated the {field}"
    }
});

});


parcelRegister("i0pIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc985af02993882e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");


var $4cifn = parcelRequire("4cifn");
const $dc985af02993882e$var$FlagHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, action: action } = historyItem;
    const flagMessage = action === (0, $1455c4053b160137$export$75936e876282682b) ? (0, $4cifn.default).added : (0, $4cifn.default).removed;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...flagMessage,
        values: {
            flag: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "flag"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $4cifn.default).flagLowercase : (0, $4cifn.default).flag))
        }
    }, (...actionText)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $4cifn.default).flag),
            from: null,
            to: null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            testId: "issue-history.ui.history-items.history-item.flag-history-item.history-item",
            actor: actor,
            action: actionText,
            timestamp: timestamp,
            change: null
        }));
};
var $dc985af02993882e$export$2e2bcd8739ae039 = $dc985af02993882e$var$FlagHistoryItem;

});
parcelRegister("4cifn", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a5b76f986bdf6ba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5a5b76f986bdf6ba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    added: {
        "id": "issue-history.history-items.history-item.flag-history-item.added",
        "defaultMessage": "added a {flag}"
    },
    removed: {
        "id": "issue-history.history-items.history-item.flag-history-item.removed",
        "defaultMessage": "removed a {flag}"
    },
    flag: {
        "id": "issue-history.history-items.history-item.flag-history-item.flag",
        "defaultMessage": "Flag"
    },
    flagLowercase: {
        "id": "issue-history.history-items.history-item.flag-history-item.flag-lowercase",
        "defaultMessage": "flag"
    }
});

});


parcelRegister("f33F6", function(module, exports) {

$parcel$export(module.exports, "default", () => $44b8ddbc382ce067$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");

var $djQa4 = parcelRequire("djQa4");

var $02bgH = parcelRequire("02bgH");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");
const $44b8ddbc382ce067$var$GenericHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, field: field, fieldType: fieldType, timestamp: timestamp, fromValue: fromValue, toValue: toValue } = historyItem;
    const normalizedField = fieldType === 'jira' ? field?.toLocaleLowerCase() : field;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $02bgH.default).updatedField,
        values: {
            field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "field"
            }, normalizedField)
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: field,
            from: fromValue != null && fromValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($44b8ddbc382ce067$var$Value, null, fromValue) : null,
            to: toValue != null && toValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($44b8ddbc382ce067$var$Value, null, toValue) : null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ), {
            testId: "issue-history.ui.history-items.generic-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: fromValue != null && fromValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($44b8ddbc382ce067$var$Value, null, fromValue) : null,
                to: toValue != null && toValue !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($44b8ddbc382ce067$var$Value, null, toValue) : null
            })
        }));
};
var $44b8ddbc382ce067$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $44b8ddbc382ce067$var$GenericHistoryItem;
const $44b8ddbc382ce067$var$Value = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug",
            __cmplp.className
        ])
    });
});
$44b8ddbc382ce067$var$Value.displayName = 'Value';

});

parcelRegister("99NbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $92fb4a3abcb31868$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");

var $djQa4 = parcelRequire("djQa4");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");
const $92fb4a3abcb31868$var$IssueCreatedHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, timestamp: timestamp } = historyItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        id: "issue.history.created-issue-type",
        defaultMessage: "created the {issue}",
        values: {
            issue: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "issueType"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                id: "issue.history.created-issue-type.issue",
                defaultMessage: "Issue"
            }))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: "Issue",
            from: null,
            to: null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.issue-created-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: null
        }));
};
var $92fb4a3abcb31868$export$2e2bcd8739ae039 = $92fb4a3abcb31868$var$IssueCreatedHistoryItem;

});

parcelRegister("8DRiG", function(module, exports) {

$parcel$export(module.exports, "default", () => $964d4456176b904b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9nkwJ = parcelRequire("9nkwJ");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");

var $djQa4 = parcelRequire("djQa4");

var $02bgH = parcelRequire("02bgH");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");
const $964d4456176b904b$var$NumericValueHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { field: field, fieldType: fieldType, actor: actor, timestamp: timestamp, fromValue: fromValue, toValue: toValue } = historyItem;
    const ChangeComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
        from: fromValue !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            max: Infinity
        }, fromValue) : null,
        to: toValue !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
            max: Infinity
        }, toValue) : null
    });
    const normalizedField = fieldType === 'jira' ? field?.toLocaleLowerCase() : field;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $02bgH.default).updatedField,
        values: {
            field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "field"
            }, normalizedField)
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: normalizedField,
            from: fromValue !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                max: Infinity
            }, fromValue) : null,
            to: toValue !== null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
                max: Infinity
            }, toValue) : null
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.numeric-value-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: ChangeComponent
        }));
};
var $964d4456176b904b$export$2e2bcd8739ae039 = $964d4456176b904b$var$NumericValueHistoryItem;

});

parcelRegister("ln6zv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4d49008c988779$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $j0dVN = parcelRequire("j0dVN");
const $7c4d49008c988779$var$ParentIssueHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, fromValue: fromValue, toValue: toValue } = historyItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $j0dVN.default).changed,
        values: {
            parent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "parent"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $j0dVN.default).parentLowercase : (0, $j0dVN.default).parent))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $j0dVN.default).parent),
            from: fromValue,
            to: toValue
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.parent-issue-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: fromValue,
                to: toValue
            })
        }));
};
var $7c4d49008c988779$export$2e2bcd8739ae039 = $7c4d49008c988779$var$ParentIssueHistoryItem;

});
parcelRegister("j0dVN", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b94d8213fb0e5f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $48b94d8213fb0e5f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changed: {
        "id": "issue-history.history-items.history-item.parent-issue-history-item.changed",
        "defaultMessage": "changed the {parent}"
    },
    parent: {
        "id": "issue-history.history-items.history-item.parent-issue-history-item.parent",
        "defaultMessage": "Parent"
    },
    parentLowercase: {
        "id": "issue-history.history-items.history-item.parent-issue-history-item.parent-lowercase",
        "defaultMessage": "parent"
    }
});

});


parcelRegister("9En2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $b933a574b0d3753e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3Il9w = parcelRequire("3Il9w");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $dxJ6t = parcelRequire("dxJ6t");
const $b933a574b0d3753e$var$PriorityHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, fromPriority: fromPriority, toPriority: toPriority } = historyItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $dxJ6t.default).changed,
        values: {
            priority: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "priority"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $dxJ6t.default).priorityLowercase : (0, $dxJ6t.default).priority))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $dxJ6t.default).priority),
            from: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Il9w.default), {
                iconUrl: fromPriority.iconUrl
            }, fromPriority.name),
            to: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Il9w.default), {
                iconUrl: toPriority.iconUrl
            }, toPriority.name)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.priority-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Il9w.default), {
                    iconUrl: fromPriority.iconUrl
                }, fromPriority.name),
                to: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Il9w.default), {
                    iconUrl: toPriority.iconUrl
                }, toPriority.name)
            })
        }));
};
var $b933a574b0d3753e$export$2e2bcd8739ae039 = $b933a574b0d3753e$var$PriorityHistoryItem;

});
parcelRegister("3Il9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdae31d75a9fc657$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hnzPP = parcelRequire("hnzPP");
function $fdae31d75a9fc657$export$2e2bcd8739ae039(props) {
    const { children: children, iconTitle: iconTitle, iconUrl: iconUrl } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fdae31d75a9fc657$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        url: iconUrl,
        title: iconTitle,
        alt: iconTitle
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fdae31d75a9fc657$var$Text, null, children));
}
$fdae31d75a9fc657$export$2e2bcd8739ae039.defaultProps = {
    iconUrl: undefined,
    iconTitle: ''
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fdae31d75a9fc657$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fdae31d75a9fc657$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dxJ6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $e261e24c750ab670$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e261e24c750ab670$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changed: {
        "id": "issue-history.history-items.history-item.priority-history-item.changed",
        "defaultMessage": "changed the {priority}"
    },
    priority: {
        "id": "issue-history.history-items.history-item.priority-history-item.priority",
        "defaultMessage": "Priority"
    },
    priorityLowercase: {
        "id": "issue-history.history-items.history-item.priority-history-item.priority-lowercase",
        "defaultMessage": "priority"
    }
});

});


parcelRegister("3cuBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b3e35dd51976ddd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $4jU7S = parcelRequire("4jU7S");

var $i5IuY = parcelRequire("i5IuY");
const $7b3e35dd51976ddd$var$RespondersHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { actor: actor, timestamp: timestamp, fromValue: fromValue, toValue: toValue } = historyItem;
    if (fromValue?.length === toValue?.length) {
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'respondersChangelogSameSize failed');
        return null;
    }
    const actionMessage = (fromValue || []).length > (toValue || []).length ? (0, $4jU7S.default).removed : (0, $4jU7S.default).added;
    const action = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...actionMessage,
        values: {
            responders: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), null, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $4jU7S.default).respondersLowercase : (0, $4jU7S.default).responders))
        }
    });
    return isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
        field: formatMessage((0, $4jU7S.default).responders),
        from: fromValue != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5IuY.RespondersList), {
            responders: fromValue
        }) : null,
        to: toValue != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5IuY.RespondersList), {
            responders: toValue
        }) : null
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
        testId: "issue-history.ui.history-items.history-item.responders-history-item.history-item",
        actor: actor,
        action: action,
        timestamp: timestamp,
        change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
            from: fromValue != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5IuY.RespondersList), {
                responders: fromValue
            }) : null,
            to: toValue != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i5IuY.RespondersList), {
                responders: toValue
            }) : null
        })
    });
};
var $7b3e35dd51976ddd$export$2e2bcd8739ae039 = $7b3e35dd51976ddd$var$RespondersHistoryItem;

});
parcelRegister("4jU7S", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c155deabc0ceade$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c155deabc0ceade$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    responders: {
        "id": "issue-history.history-items.history-item.responders-history-item.responders",
        "defaultMessage": "Responders"
    },
    respondersLowercase: {
        "id": "issue-history.history-items.history-item.responders-history-item.responders-lowercase",
        "defaultMessage": "responders"
    },
    added: {
        "id": "issue-history.history-items.history-item.responders-history-item.added",
        "defaultMessage": "added {responders}"
    },
    removed: {
        "id": "issue-history.history-items.history-item.responders-history-item.removed",
        "defaultMessage": "removed {responders}"
    }
});

});

parcelRegister("i5IuY", function(module, exports) {

$parcel$export(module.exports, "RespondersList", () => $0aacc980a40a8485$export$7334f78b3f38f2d3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $iJlfe = parcelRequire("iJlfe");

var $4nce6 = parcelRequire("4nce6");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");


var $94Uzu = parcelRequire("94Uzu");
const $0aacc980a40a8485$export$7334f78b3f38f2d3 = ({ responders: responders })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aacc980a40a8485$var$ListWrapper, null, responders.map(({ ari: ari, avatarUrl: avatarUrl, name: name, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aacc980a40a8485$var$ResponderContainer, {
            key: ari
        }, type === (0, $1455c4053b160137$export$1187c3553ecd80a1) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aacc980a40a8485$var$AvatarContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: avatarUrl,
            size: "small"
        })), name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aacc980a40a8485$var$TeamIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
            label: formatMessage((0, $94Uzu.default).teamIconLabel),
            size: "medium"
        })), !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(name) ? name : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            testId: "issue-history.ui.history-items.history-item.responders-history-item.responders-list.responders-list-tooltip",
            content: formatMessage((0, $94Uzu.default).noOpgenieAccessTeamNameTooltipMessage)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0aacc980a40a8485$var$DisabledWrapper, null, formatMessage((0, $94Uzu.default).noTeamNameMessage)))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aacc980a40a8485$var$DisabledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz81fd _80om73ad",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aacc980a40a8485$var$ListWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $0aacc980a40a8485$var$ResponderContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _otyr12x7",
            __cmplp.className
        ])
    });
});
const $0aacc980a40a8485$var$AvatarContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1f4h _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $0aacc980a40a8485$var$TeamIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg _2hwxu2gc _2rko1ssb _11q71yrq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("94Uzu", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a7bedfcdb5478a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $39a7bedfcdb5478a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-history.history-items.history-item.responders-history-item.responders-list.none",
        "defaultMessage": "None"
    },
    teamIconLabel: {
        "id": "issue-history.history-items.history-item.responders-history-item.responders-list.team-icon-label",
        "defaultMessage": "Responder team icon"
    },
    noTeamNameMessage: {
        "id": "issue-history.history-items.history-item.responders-history-item.responders-list.no-team-name-message",
        "defaultMessage": "Team"
    },
    noOpgenieAccessTeamNameTooltipMessage: {
        "id": "issue-history.history-items.history-item.responders-history-item.responders-list.no-opgenie-access-team-name-tooltip-message",
        "defaultMessage": "You need Opsgenie access to view this team"
    }
});

});



parcelRegister("hVngm", function(module, exports) {

$parcel$export(module.exports, "default", () => $b265bd6f36f20933$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6zOB7 = parcelRequire("6zOB7");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $djQa4 = parcelRequire("djQa4");

var $02bgH = parcelRequire("02bgH");

var $6Kuhf = parcelRequire("6Kuhf");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $cFR7B = parcelRequire("cFR7B");
const $b265bd6f36f20933$var$RichTextHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, field: field, fieldType: fieldType, timestamp: timestamp, toValue: toValue } = historyItem;
    const normalizedField = fieldType === 'jira' ? field?.toLocaleLowerCase() : field;
    const [isExpanded, setIsExpanded] = (0, $eUqFw.useState)(false);
    const contentRef = (0, $eUqFw.useRef)(null);
    const [isClamped, setClamped] = (0, $eUqFw.useState)(false);
    const intl = (0, $4ksts.useIntlV2)();
    (0, $eUqFw.useEffect)(()=>{
        if (contentRef && contentRef.current) setClamped(contentRef.current.scrollHeight > contentRef.current.clientHeight);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $02bgH.default).updatedField,
        values: {
            field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "field"
            }, normalizedField)
        }
    }, (...action)=>isGrouped ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            isRichTextField: true,
            field: field,
            to: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b265bd6f36f20933$var$containerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                ref: contentRef,
                xcss: isExpanded ? $b265bd6f36f20933$var$textStyles : $b265bd6f36f20933$var$textStylesTruncated
            }, toValue || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b265bd6f36f20933$var$Subtle, null, intl.formatMessage((0, $6Kuhf.default).none))), isClamped && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b265bd6f36f20933$var$showMoreButtonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                appearance: "subtle",
                spacing: "none",
                onClick: ()=>setIsExpanded((prevIsExpanded)=>!prevIsExpanded)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), isExpanded ? (0, $cFR7B.default).showLess : (0, $cFR7B.default).showMore))))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            testId: "issue-history.ui.history-items.history-item.rich-text-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b265bd6f36f20933$var$containerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                ref: contentRef,
                xcss: isExpanded ? $b265bd6f36f20933$var$textStyles : $b265bd6f36f20933$var$textStylesTruncated
            }, toValue || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b265bd6f36f20933$var$Subtle, null, intl.formatMessage((0, $6Kuhf.default).none))), isClamped && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b265bd6f36f20933$var$showMoreButtonStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                appearance: "subtle",
                spacing: "none",
                onClick: ()=>setIsExpanded((prevIsExpanded)=>!prevIsExpanded)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), isExpanded ? (0, $cFR7B.default).showLess : (0, $cFR7B.default).showMore))))
        }));
};
const $b265bd6f36f20933$var$textStyles = (0, $1ZAYh.xcss)({
    overflowX: 'auto'
});
const $b265bd6f36f20933$var$textStylesTruncated = (0, $1ZAYh.xcss)({
    overflowX: 'auto',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
});
const $b265bd6f36f20933$var$showMoreButtonStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingTop: 'space.050'
});
const $b265bd6f36f20933$var$containerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    color: 'color.text.subtle',
    overflowWrap: 'anywhere'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b265bd6f36f20933$var$Subtle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});
$b265bd6f36f20933$var$Subtle.displayName = 'Subtle';
var $b265bd6f36f20933$export$2e2bcd8739ae039 = $b265bd6f36f20933$var$RichTextHistoryItem;

});
parcelRegister("cFR7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $70b9e094373361c5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $70b9e094373361c5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMore: {
        "id": "issue-history.history-items.history-item.rich-text-history-item.show-more",
        "defaultMessage": "Show more"
    },
    showLess: {
        "id": "issue-history.history-items.history-item.rich-text-history-item.show-less",
        "defaultMessage": "Show less"
    }
});

});


parcelRegister("5euWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $439603b10ccd76b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $h9cCP = parcelRequire("h9cCP");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $djQa4 = parcelRequire("djQa4");

var $6bhHe = parcelRequire("6bhHe");

var $7v0hO = parcelRequire("7v0hO");

var $02bgH = parcelRequire("02bgH");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");
const $439603b10ccd76b1$var$TimeChangedHistoryItemView = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, timestamp: timestamp, fromTime: fromTime, toTime: toTime, field: field, fieldType: fieldType } = historyItem;
    const [config] = (0, $6bhHe.useTimeTrackingConfiguration)();
    const intl = (0, $4ksts.useIntlV2)();
    let from = fromTime;
    let to = toTime;
    if (config) {
        const formatterConfig = {
            workingHoursPerDay: config.hoursPerDay,
            workingDaysPerWeek: config.daysPerWeek,
            timeFormat: config.format || (0, $h9cCP.PRETTY),
            defaultUnit: config.defaultUnit
        };
        if (typeof fromTime === 'number') // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number | null'.
        from = (0, $7v0hO.timeTrackingFormatter)(fromTime, formatterConfig, intl);
        if (typeof toTime === 'number') // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number | null'.
        to = (0, $7v0hO.timeTrackingFormatter)(toTime, formatterConfig, intl);
    }
    const normalizedField = fieldType === 'jira' ? field?.toLocaleLowerCase() : field;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $02bgH.default).updatedField,
        values: {
            field: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "field"
            }, normalizedField)
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: field,
            from: from !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, from),
            to: to !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, to)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.time-changed-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: from !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, from),
                to: to !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), null, to)
            })
        }));
};
var $439603b10ccd76b1$export$2e2bcd8739ae039 = $439603b10ccd76b1$var$TimeChangedHistoryItemView;

});
parcelRegister("h9cCP", function(module, exports) {

$parcel$export(module.exports, "MINUTE", () => $335f9886067ef898$export$f4aba04677f37907);
$parcel$export(module.exports, "HOUR", () => $335f9886067ef898$export$1bf939ebcf31ef0e);
$parcel$export(module.exports, "DAY", () => $335f9886067ef898$export$1a58b8d7f494dd72);
$parcel$export(module.exports, "WEEK", () => $335f9886067ef898$export$3241045aa1844a20);
$parcel$export(module.exports, "DAYS", () => $335f9886067ef898$export$b387b66963374517);
$parcel$export(module.exports, "HOURS", () => $335f9886067ef898$export$f25ebc73c10ad2c);
$parcel$export(module.exports, "PRETTY", () => $335f9886067ef898$export$d39e6ebabedff673);
$parcel$export(module.exports, "defaultTimeTrackingConfiguration", () => $335f9886067ef898$export$e17ebf14f4144ede);
$parcel$export(module.exports, "DEFAULT_TO_NEW_ISSUE_VIEW", () => $335f9886067ef898$export$83f9ac2d887bd06a);
const $335f9886067ef898$export$f4aba04677f37907 = 'minute';
const $335f9886067ef898$export$1bf939ebcf31ef0e = 'hour';
const $335f9886067ef898$export$1a58b8d7f494dd72 = 'day';
const $335f9886067ef898$export$3241045aa1844a20 = 'week';
const $335f9886067ef898$export$b387b66963374517 = 'days';
const $335f9886067ef898$export$f25ebc73c10ad2c = 'hours';
const $335f9886067ef898$export$d39e6ebabedff673 = 'pretty';
const $335f9886067ef898$export$e17ebf14f4144ede = {
    isTimeTrackingEnabled: false,
    daysPerWeek: 5,
    hoursPerDay: 8,
    defaultUnit: $335f9886067ef898$export$f4aba04677f37907,
    format: $335f9886067ef898$export$d39e6ebabedff673
};
const $335f9886067ef898$export$7a0204710d322de6 = 'LOCK_IN_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$83f9ac2d887bd06a = 'DEFAULT_TO_NEW_ISSUE_VIEW';
const $335f9886067ef898$export$f269c0bf10ad77e2 = 'DEFAULT_TO_OLD_ISSUE_VIEW';

});

parcelRegister("6bhHe", function(module, exports) {

$parcel$export(module.exports, "useTimeTrackingConfiguration", () => $3f1d18787644dd25$export$57b83fc8c963078f);
$parcel$export(module.exports, "useJiraSettingsActions", () => $3f1d18787644dd25$export$6f294bed8b806bfb);

var $eUqFw = parcelRequire("eUqFw");

var $3poNT = parcelRequire("3poNT");
const $3f1d18787644dd25$export$57b83fc8c963078f = ()=>{
    const [timeTrackingConfiguration] = (0, $3poNT.useJiraSettingStoreTimeTracking)();
    return [
        timeTrackingConfiguration
    ];
};
const $3f1d18787644dd25$export$a0b7933d1ba1359a = ()=>{
    const [subTaskConfiguration] = (0, $3poNT.useJiraSettingStoreSubtaskConfiguration)();
    return [
        subTaskConfiguration
    ];
};
const $3f1d18787644dd25$export$e8c8fa84fe64255f = ()=>{
    const [issueLinkTypes] = (0, $3poNT.useJiraSettingStoreIssueLinkType)();
    return [
        issueLinkTypes
    ];
};
const $3f1d18787644dd25$export$311fcda1c9d987e1 = ()=>{
    const [newIssueViewTransitionSetting] = (0, $3poNT.useJiraSettingStoreNewIssueViewTransition)();
    return [
        newIssueViewTransitionSetting
    ];
};
const $3f1d18787644dd25$export$6f294bed8b806bfb = ()=>{
    const [, { setJiraSettings: setJiraSettings }] = (0, $3poNT.useSettingsActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setJiraSettings: setJiraSettings
        }), [
        setJiraSettings
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("3poNT", function(module, exports) {

$parcel$export(module.exports, "useJiraSettingStoreTimeTracking", () => $0979f93719382ebd$export$a02b4a407a2f26d4);
$parcel$export(module.exports, "useJiraSettingStoreNewIssueViewTransition", () => $0979f93719382ebd$export$ef5d1a1edee065c3);
$parcel$export(module.exports, "useJiraSettingStoreSubtaskConfiguration", () => $0979f93719382ebd$export$fb7d68c140cb341f);
$parcel$export(module.exports, "useJiraSettingStoreIssueLinkType", () => $0979f93719382ebd$export$b0a0062863e9885a);
$parcel$export(module.exports, "useSettingsActions", () => $0979f93719382ebd$export$346f2dc8b103b21d);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $h9cCP = parcelRequire("h9cCP");

var $2YHa8 = parcelRequire("2YHa8");
const $0979f93719382ebd$export$d4c72bab9d6cc13a = {
    newIssueViewTransitionSettings: {
        newIssueViewTransitionLockingStatus: (0, $h9cCP.DEFAULT_TO_NEW_ISSUE_VIEW),
        shouldDelayChangeboarding: false
    },
    issueLinkTypes: [],
    subtasksConfiguration: {
        enabled: true
    },
    timeTrackingConfiguration: {
        isTimeTrackingEnabled: false,
        daysPerWeek: 0,
        hoursPerDay: 0,
        // Possible values for defaultUnit can be: minute, hour, day, and week.
        defaultUnit: (0, $h9cCP.MINUTE)
    }
};
const $0979f93719382ebd$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'jiraSettings',
    initialState: $0979f93719382ebd$export$d4c72bab9d6cc13a,
    actions: $2YHa8
});
// remove undefined when we remove ff issue.details.admin-options-phase-2
const $0979f93719382ebd$var$getTimeTracking = (state)=>state.timeTrackingConfiguration;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $0979f93719382ebd$var$getNewIssueViewTransition = (state)=>state.newIssueViewTransitionSettings || undefined;
const $0979f93719382ebd$var$getSubtaskConfiguration = (state)=>state.subtasksConfiguration;
const $0979f93719382ebd$var$getIssueLinkType = (state)=>state.issueLinkTypes;
const $0979f93719382ebd$export$a02b4a407a2f26d4 = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getTimeTracking
});
const $0979f93719382ebd$export$ef5d1a1edee065c3 = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getNewIssueViewTransition
});
const $0979f93719382ebd$export$fb7d68c140cb341f = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getSubtaskConfiguration
});
const $0979f93719382ebd$export$b0a0062863e9885a = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: $0979f93719382ebd$var$getIssueLinkType
});
const $0979f93719382ebd$export$346f2dc8b103b21d = (0, $ggKAj.createHook)($0979f93719382ebd$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("2YHa8", function(module, exports) {

$parcel$export(module.exports, "setJiraSettings", () => $2ee1115fea197613$export$aa595a6ada3acbb8);
const $2ee1115fea197613$export$aa595a6ada3acbb8 = (jiraSettings)=>({ setState: setState })=>{
        setState(jiraSettings);
    };

});



parcelRegister("7v0hO", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $84936c9163886c98$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $84936c9163886c98$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $84936c9163886c98$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $84936c9163886c98$export$8516173ab945b52f);

var $4m36T = parcelRequire("4m36T");

var $eyAhE = parcelRequire("eyAhE");

var $3W1DB = parcelRequire("3W1DB");
const $84936c9163886c98$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $84936c9163886c98$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $84936c9163886c98$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $84936c9163886c98$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $4m36T.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $4m36T.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $4m36T.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $4m36T.defaultTimeTrackingOptions).defaultUnit
    };
    return $84936c9163886c98$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $84936c9163886c98$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $4m36T.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $3W1DB.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $eyAhE.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $eyAhE.default).timeUnitLongDay,
            transform: $84936c9163886c98$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $eyAhE.default).timeUnitLongHour,
            transform: $84936c9163886c98$var$validate(isTimeValid),
            seconds: (0, $4m36T.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $eyAhE.default).timeUnitLongMinute,
            seconds: (0, $4m36T.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $4m36T.TimeFormats).DAYS:
            return $84936c9163886c98$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $4m36T.TimeFormats).HOURS:
            return $84936c9163886c98$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $4m36T.TimeFormats).PRETTY:
        default:
            return $84936c9163886c98$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $84936c9163886c98$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $4m36T.TimeFormats).DAYS:
            return (0, $4m36T.TimeFormats).DAYS;
        case (0, $4m36T.TimeFormats).HOURS:
            return (0, $4m36T.TimeFormats).HOURS;
        case (0, $4m36T.TimeFormats).PRETTY:
            return (0, $4m36T.TimeFormats).PRETTY;
        default:
            return (0, $4m36T.TimeFormats).DAYS;
    }
};
const $84936c9163886c98$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $4m36T.TimeUnits).DAY:
            return (0, $4m36T.TimeUnits).DAY;
        case (0, $4m36T.TimeUnits).HOUR:
            return (0, $4m36T.TimeUnits).HOUR;
        case (0, $4m36T.TimeUnits).MINUTE:
            return (0, $4m36T.TimeUnits).MINUTE;
        case (0, $4m36T.TimeUnits).WEEK:
            return (0, $4m36T.TimeUnits).WEEK;
        default:
            return (0, $4m36T.TimeUnits).DAY;
    }
};

});
parcelRegister("4m36T", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $8d43f29047a2cbec$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $8d43f29047a2cbec$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $8d43f29047a2cbec$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $8d43f29047a2cbec$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $8d43f29047a2cbec$export$f8d48c1fed813e90);
const $8d43f29047a2cbec$export$544c576050746347 = 60;
const $8d43f29047a2cbec$export$a4982fdb1458274 = 60;
const $8d43f29047a2cbec$export$3cc7ae4b390f50a = $8d43f29047a2cbec$export$a4982fdb1458274 * $8d43f29047a2cbec$export$544c576050746347;
const $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY = 'pretty';
const $8d43f29047a2cbec$var$TIME_FORMAT_DAYS = 'days';
const $8d43f29047a2cbec$var$TIME_FORMAT_HOURS = 'hours';
const $8d43f29047a2cbec$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $8d43f29047a2cbec$var$TIME_FORMAT_PRETTY,
    DAYS: $8d43f29047a2cbec$var$TIME_FORMAT_DAYS,
    HOURS: $8d43f29047a2cbec$var$TIME_FORMAT_HOURS
});
const $8d43f29047a2cbec$var$TIME_UNIT_WEEK = 'week';
const $8d43f29047a2cbec$var$TIME_UNIT_DAY = 'day';
const $8d43f29047a2cbec$var$TIME_UNIT_HOUR = 'hour';
const $8d43f29047a2cbec$var$TIME_UNIT_MINUTE = 'minute';
const $8d43f29047a2cbec$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $8d43f29047a2cbec$var$TIME_UNIT_WEEK,
    DAY: $8d43f29047a2cbec$var$TIME_UNIT_DAY,
    HOUR: $8d43f29047a2cbec$var$TIME_UNIT_HOUR,
    MINUTE: $8d43f29047a2cbec$var$TIME_UNIT_MINUTE
});
const $8d43f29047a2cbec$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $8d43f29047a2cbec$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $8d43f29047a2cbec$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("eyAhE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93ae5507f3c0ae3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a93ae5507f3c0ae3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("3W1DB", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $1595a85c80e57d00$export$aab44654646f3ccc);
const $1595a85c80e57d00$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});



parcelRegister("e9ota", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdf0580889115a4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3ySoA = parcelRequire("3ySoA");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $jVbrS = parcelRequire("jVbrS");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $5J6TQ = parcelRequire("5J6TQ");
const $0bdf0580889115a4$var$TransitionHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { actor: actor, timestamp: timestamp, fromStatus: fromStatus, toStatus: toStatus } = historyItem;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $5J6TQ.default).changed,
        values: {
            status: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "status"
            }, formatMessage((0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? (0, $5J6TQ.default).statusLowercase : (0, $5J6TQ.default).status))
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $5J6TQ.default).status),
            from: fromStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
                category: fromStatus.statusCategory,
                name: fromStatus.name
            }),
            to: toStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
                category: toStatus.statusCategory,
                name: toStatus.name
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.transition-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jVbrS.default), {
                from: fromStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
                    category: fromStatus.statusCategory,
                    name: fromStatus.name
                }),
                to: toStatus && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3ySoA.default), {
                    category: toStatus.statusCategory,
                    name: toStatus.name
                })
            })
        }));
};
var $0bdf0580889115a4$export$2e2bcd8739ae039 = $0bdf0580889115a4$var$TransitionHistoryItem;

});
parcelRegister("3ySoA", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ca0a8de67cc8ac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $8Qd0L = parcelRequire("8Qd0L");
const $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap = {
    [(0, $8Qd0L.UNDEFINED)]: 'default',
    [(0, $8Qd0L.TODO)]: 'default',
    [(0, $8Qd0L.DONE)]: 'success',
    [(0, $8Qd0L.IN_PROGRESS)]: 'inprogress'
};
class $84ca0a8de67cc8ac$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $84ca0a8de67cc8ac$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});

parcelRegister("5J6TQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6716bb5e1aad6e2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a6716bb5e1aad6e2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changed: {
        "id": "issue-history.history-items.history-item.transition-history-item.changed",
        "defaultMessage": "changed the {status}"
    },
    status: {
        "id": "issue-history.history-items.history-item.transition-history-item.status",
        "defaultMessage": "Status"
    },
    statusLowercase: {
        "id": "issue-history.history-items.history-item.transition-history-item.status-lowercase",
        "defaultMessage": "status"
    }
});

});


parcelRegister("akKru", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c1584792eb1d167$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $djQa4 = parcelRequire("djQa4");

var $k4aVr = parcelRequire("k4aVr");

var $53f0u = parcelRequire("53f0u");

var $jxYRz = parcelRequire("jxYRz");
const $5c1584792eb1d167$var$WorklogHistoryItem = ({ historyItem: historyItem, isGrouped: isGrouped = false })=>{
    const { actor: actor, timestamp: timestamp, comment: comment, timeSpent: timeSpent } = historyItem;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $jxYRz.default).loggedWork,
        values: {
            time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                key: "priority"
            }, timeSpent)
        }
    }, (...action)=>isGrouped && (0, $79xbN.expVal)('issue_view_activity_timeline', 'isActivityTimelineEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k4aVr.default), {
            field: formatMessage((0, $jxYRz.default).loggedWork, {
                time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djQa4.Emphasise), {
                    key: "priority"
                }, timeSpent)
            })
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53f0u.default), {
            // eslint-disable-next-line jira/integration/test-id-by-folder-structure
            testId: "issue-history.ui.history-items.worklog-history-item.history-item",
            actor: actor,
            action: action,
            timestamp: timestamp,
            change: comment
        }));
};
var $5c1584792eb1d167$export$2e2bcd8739ae039 = $5c1584792eb1d167$var$WorklogHistoryItem;

});
parcelRegister("jxYRz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea495a367d2073cc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ea495a367d2073cc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loggedWork: {
        "id": "issue-history.history-items.history-item.worklog-history-item.logged-work",
        "defaultMessage": "logged {time}"
    }
});

});



parcelRegister("5saHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b8501a8cfd3752a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8b8501a8cfd3752a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadMore: {
        "id": "issue-history.history-items.load-more",
        "defaultMessage": "Load more"
    }
});

});





//# sourceMappingURL=async-jira-issue-history.49b02c82.js.map
